import * as _ from 'lodash';
import { pdf } from '@react-pdf/renderer';
import Receipt from '../models/Receipt';
import { PDFDocument } from 'pdf-lib';
import type { PDFPageProxy, PDFDocumentProxy } from 'pdfjs-dist';
import { pdfjs } from 'react-pdf';
// import { AnyObject } from 'final-form';
import { AppContext } from 'src/providers/AppContextProvider';
import { IAppContextState } from 'src/reducers/AppContext';
import RHFCheckbox from 'src/components/controls/tempRHFControls/RHFCheckBox';
import React, { useState, useEffect, useContext, ChangeEvent, useRef } from 'react';
import { ODataOptions, ODataFilter, ODataFilterOperators, ODataOrderByDirection } from 'src/util/ODataBuilder';
import { ITableConfig } from 'src/components/common/table';
import useFetch from 'use-http';
import PBNavBar from '../PBNavBar';
import { useForm } from 'react-hook-form';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import ClientProjectSearch from 'src/components/project-billing/components/ClientProjectSearch';
import TsdiClient from 'src/models/AP/Client';
import TsdiOffice from 'src/models/AP/TsdiOffice';
import { BiAddToQueue, BiLeftArrowAlt, BiRightArrowAlt, BiArrowToLeft, BiArrowToRight } from 'react-icons/bi';
import ReceiptViewerDialog from 'src/components/client-project/dialogs/ReceiptViewerDialog';
import { FaInfoCircle, FaArrowUp, FaBan, FaFileSignature } from 'react-icons/fa';
import DialogList from 'src/dialogs';
import actions from 'src/actions';
import { useDispatch } from 'react-redux';
// import { push } from 'connected-react-router';
import InvoiceGroupCoverLetterPdf from '../components/InvoiceGroupCoverLetterPdf';
import Invoice from 'src/components/project-billing/models/InvoiceMaster';
import InvoiceDetail from '../models/InvoiceDetail';
import PayPeriod from 'src/models/AP/PayPeriod';
import CreateInvoiceDialog from '../dialogs/CreateInvoiceDialog';
import GenerateInvoiceListingDialog from '../dialogs/GenerateInvoiceListingDialog';
import InvoiceDescriptionDialog from '../dialogs/InvoiceDescriptionDialog';
import GenerateTimesheetDialog from '../dialogs/GenerateTimesheetDialog';
import GenerateTimeSummaryDialog from '../dialogs/GenerateTimeSummaryDialog';
import InvoiceDocument from '../models/InvoiceDocument';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
/* import { FaEye, FaInfoCircle } from 'react-icons/fa';
import { PDFDownloadLink } from '@react-pdf/renderer';*/
// import { IInvoiceDocument } from '../components/InvoicePdf';
// import InvoicePdf from '../components/InvoicePdf';
import { IInvoiceGroupCoverLetterDocument } from '../components/InvoiceGroupCoverLetterPdf';
import ProspectDetails from 'src/models/projectSettings/TsdiProspect';
import InvoiceBreakdownDialog from '../dialogs/InvoiceBreakdownDialog';
import GenerateInvoicesDialog from '../dialogs/GenerateInvoicesDialog';
import EditInvoiceGroupNameDialog from '../dialogs/EditInvoiceGroup';
import InvoiceDetailsDialog from '../dialogs/InvoiceDetailsDialog';
import VoidInvoiceDialog from '../dialogs/VoidInvoiceDialog';
import InvoiceDocumentCreationDialog from '../dialogs/InvoiceDocumentCreationDialog';
import InvoiceDocumentManagementDialog from '../dialogs/InvoiceDocumentManagementDialog';
import InvoiceDoc from '../models/InvoiceDoc';
import InvoiceType from '../models/InvoiceType';
import TimeSheet from '../models/Timesheet';
import AddInvoiceDocumentDialog from '../dialogs/AddDocumentDialog';
import './InvoiceMaintenance.scss';
import { InvoiceGeneration } from '../models/InvoiceGeneration';
import { useSelector } from 'react-redux';
import { IRootState } from 'src/reducers';
import { selectors } from 'src/reducers/Layout';
import TsdiAltSubcode from 'src/models/AP/AltSubcode';
import TsdiSubcode from 'src/models/AP/Subcode';
import InvoiceGroupSubcode from 'src/models/AP/InvoiceGroupSubcode';
import { useServiceCtx } from '../components/TimeAndExpenseServiceContext';
import CreateInvoiceValidationResult from 'src/components/project-billing/models/CreateInvoiceValidation';
import InvoiceValidation from  'src/components/project-billing/models/InvoiceValidation';
import ErrorResponse from 'src/models/ErrorResponse';
import InvoiceGroupingDialog from 'src/components/client-project/dialogs/InvoiceGroupingDialog';
import TsdiInvoiceGroup from 'src/components/project-billing/models/InvoiceGroup';
import InvoiceGroupCoverLetterDialog from 'src/components/project-billing/dialogs/InvoiceGroupCoverLetterDialog';
import GenerateExcelSummaryDialog from 'src/components/project-billing/dialogs/GenerateExcelSummaryDialog';
import GenerateExcelInvoiceListDialog from 'src/components/project-billing/dialogs/GenerateExcelInvoiceListDialog';
import GenerateSupplierLinkCsvDialog from 'src/components/project-billing/dialogs/GenerateSupplierLinkCsvDialog';
import NoSelectedInvoicesWarningDialog from 'src/components/accounts-payable/dialogs/NoSelectedInvoicesWarningDialog';
import ConfirmGenerateInvoiceDocumentsDialog from 'src/components/accounts-payable/dialogs/ConfirmGenerateInvoiceDocumentsDialog';
import { InvoiceGroupCoverLetter } from '../models/InvoiceGroupCoverLetter';
import TsdiInvoiceGroupRequest from '../models/InvoiceGroupRequest';
import { AnyObject } from 'final-form';

// Todo: The list of invoices will need to be virtualized so that Select All operates on all the rows in the database and not just what we can load in the UI
// import { FixedSizeList as List } from "react-window";

const InvoiceMaintenancePageComponent = () => {
    const dispatch = useDispatch();
    const appContext = useContext<IAppContextState>(AppContext);
    const { register, reset, errors, getValues, setValue} = useForm();
    const { get, put, post, del, response } = useFetch();
    const { get: getBinary, /*post: postBinary,*/ response: responseBinary } = useFetch('/v1.0', {
        responseType: 'arrayBuffer' // only applies to this instance
      });
    const isGeneratingZip = useSelector((state: IRootState) => selectors.isGeneratingZip(state));
    const isGeneratingInvoices = useSelector((state: IRootState) => selectors.isGeneratingInvoices(state));
    const isGeneratingDocuments = useSelector((state: IRootState) => selectors.isGeneratingDocuments(state));
/*     const { post: postBinary, response: responseBinary} = useFetch('http://localhost:4000/api', {
        headers: {
          'Content-Type': 'application/pdf'
        },
        // 👇 this is the key setting
        interceptors: {
          request: async ({ options, url, path, route }) => {
            // Prevent use-http from JSON-stringifying blobs
            if (options.headers && typeof options.headers === 'object') {
                const filtered: Record<string, string> = {};
                for (const [key, value] of Object.entries(options.headers)) {
                  // Remove the rogue contentType header (case-insensitive)
                  if (key.toLowerCase() !== 'contenttype') {
                    filtered[key] = value;
                  }
                }

                options.headers = filtered;
            }
            return options;
          }
        }
      }); */
    const {
        validateBillingCode,
        validateSection
    } = useServiceCtx();
    const [relaunchDialog, setRelaunchDialog] = useState<DialogList>(undefined);
    const [creatingGroup, setCreatingGroup] = useState<Array<InvoiceGroupSubcode>>(undefined);
    const [addSections, setAddSections] = useState<boolean>(undefined);
    const [receiptViewContext, setReceiptViewContext] = useState<number>(undefined);
    const [invoiceGroupSubcodeSearchOptions, setInvoiceGroupSubcodeSearchOptions] = useState<ODataOptions>(new ODataOptions());
    const [igSubcodes, setIgSubcodes] = useState<Array<InvoiceGroupSubcode>>(undefined);
    const [receiptThumbnails, setReceiptThumbnails] = useState<Array<Receipt>>(undefined);
    const [invoiceThumbnails, setInvoiceThumbnails] = useState<Array<Receipt>>(undefined);
    const [clients, setClients] = useState<Array<TsdiClient>>(undefined);
    const [offices, setOffices] = useState<Array<TsdiOffice>>(undefined);
    const [clientSearchOptions, setClientSearchOptions] = useState<ODataOptions>(undefined);
    const [invoiceSearchOptions, setInvoiceSearchOptions] = useState<ODataOptions>(undefined);
    const [fetchNextInvoicePage, setFetchNextInvoicePage] = useState<boolean>(true);
    const [selectedClient, setSelectedClient] = useState<TsdiClient>(undefined);
    const [selectedClientNumber, setSelectedClientNumber] = useState<number>(undefined);
    const [selectedSource, setSelectedSource] = useState<string>(undefined);
    const [selectedPayPeriod, setSelectedPayPeriod] = useState<string>(undefined);
    const [selectedTotal, setSelectedTotal] = useState<number>(undefined);
    const [selectedGroupNumber, setSelectedGroupNumber] = useState<number>(undefined);
    const [payPeriodSearchOptions, setPayPeriodSearchOptions] = useState<ODataOptions>(undefined);
    const [fetchNextPayPeriodsPage, setFetchNextPayPeriodsPage] = useState<boolean>(true);
    const [payPeriodSearchTerm, setPayPeriodSearchTerm] = useState<string>('');
    const [selectedOffice, setSelectedOffice] = useState<string>(undefined);
    const [showInvoiceGroups, setShowInvoiceGroups] = useState<boolean>(false);
    const [enableInvoiceMaster, setEnableInvoiceMaster] = useState<boolean>(false);
    const [selectedBeginDate, setSelectedBeginDate] = useState<Date>(undefined);
    const [selectedEndDate, setSelectedEndDate] = useState<Date>(undefined);
    const [selectedInvoiceDate, setSelectedInvoiceDate] = useState<Date>(undefined);
    const [selectedProject, setSelectedProject] = useState<ProspectDetails>(undefined);
    const [selectedProjectNumber, setSelectedProjectNumber] = useState<number>(undefined);
    const [selectedSubcode, setSelectedSubcode] = useState<TsdiSubcode>(undefined);
    const [selectedFormat, setSelectedFormat] = useState<string>(undefined);
    const [selectedCreatedByNumber, setSelectedCreatedByNumber] = useState<number>(undefined);
    const [selectedAltSubcode, setSelectedAltSubcode] = useState<TsdiAltSubcode>(undefined);
    const [loadingInvoices, setLoadingInvoices] = useState<boolean>(false);
    const [invoices, setInvoices] = useState<Array<Invoice>>(undefined);
    const [invoiceValidationData, setInvoiceValidationData] = useState<InvoiceValidation>(undefined);
    const [invoiceDetail, setInvoiceDetail] = useState<InvoiceDetail>(undefined);
    const [selectedInvoiceIndex, setSelectedInvoiceIndex] = useState<number>(undefined);
    const [payPeriods, setPayPeriods] = useState<Array<PayPeriod>>(undefined);
    const [tsdiNumber, setTsdiNumber] = useState<number>(undefined);
    const [igCoverLetterBytes, setIgCoverLetterBytes] = useState<Uint8Array>(undefined);
    const [tsdiName, setTsdiName] = useState<string>(undefined);
    const [openInvoiceGrouping, setOpenInvoiceGrouping] = useState<Object>(undefined);
    const [openGenerateIgDocs, setOpenGenerateIgDocs] = useState<Object>(undefined);
    // const [invoiceDocument, setInvoiceDocument] = useState<InvoiceDocument>(undefined);
    const [invoiceDocs, setInvoiceDocs] = useState<Array<InvoiceDoc>>(undefined);
    const [invoiceGroupDocs, setInvoiceGroupDocs] = useState<Array<InvoiceDoc>>(undefined);
    const [archivedInvoiceDocs, setArchivedInvoiceDocs] = useState<Array<InvoiceDoc>>(undefined);
    const [invoiceDocsForUpload, setInvoiceDocsForUpload] = useState<Array<InvoiceDoc>>(undefined);
    const [invoiceSearchTerm, setInvoiceSearchTerm] = useState<string>(undefined);
    const [clientSearchTerm, setClientSearchTerm] = useState<string>('');
    const [invoiceTypes, setInvoiceTypes] = useState<Array<InvoiceType>>(undefined);
    const [invoiceDetailTypes, setInvoiceDetailTypes] = useState<Array<InvoiceType>>(undefined);
    // const [officeExpenseReceiptBlob, setOfficeExpenseReceiptBlob] = useState<Blob>(null);
    const [expenseReceiptBlob, setExpenseReceiptBlob] = useState<Blob>(null);
    const [openDocumentManagement, setOpenDocumentManagement] = useState<object>(null);
    const [openInvoiceGroups, setOpenInvoiceGroups] = useState<object>(null);
    const [openArchiveReasonDialog, setOpenArchiveReasonDialog] = useState<object>(null);
    const [openGenerateTimesheet, setOpenGenerateTimesheet] = useState<object>(null);
    const [generatingDocument, setGeneratingDocument] = useState<boolean>(null);
    const [updatingDocument, setUpdatingDocument] = useState<{ docId: number, archiveAction: number}>(null);
    const [invoiceGroup, setInvoiceGroup] = useState<TsdiInvoiceGroup>(undefined);
    const [igNumber, setIgNumber] = useState<string>(undefined);
    const [invoiceGroups, setInvoiceGroups] = useState<Array<TsdiInvoiceGroup>>(undefined);
    const [invoiceGroupRequests, setInvoiceGroupRequests] = useState<Array<TsdiInvoiceGroupRequest>>(undefined);
    const [executeInvoiceQuery, setExecuteInvoiceQuery] = useState<object>(undefined);
    const [officeOptionValues, setOfficeOptionValues] = useState<Array<{value: string, label: string}>>(null);
    const excludePostedInvoices = useRef(false);
    const excludeUnPostedInvoices = useRef(false);
    const excludeNonVoidInvoices = useRef(false);
    const excludeVoidInvoices = useRef(false);
    const sortDirection = useRef(true);
    const totalLike = useRef(false);
    // const { isDirty, dirtyFields } = formState;

    // Initial render
    useEffect(() => {
        onCreate();

        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        if (Array.isArray(offices)) {
            setOfficeOptionValues(offices.map((o: TsdiOffice, index) => { return { value: o?.id ? o.id.toString() : index.toString(), label: o?.office}; }));
        }
    }, [offices]);

    useEffect(() => {
        if (Array.isArray(invoiceGroupRequests)) {
            showInvoiceGroupCoverLetterDialog();
        }
    }, [invoiceGroupRequests]);

    useEffect(() => {
        if (executeInvoiceQuery) {
            resetInvoiceSearchOptions();
        }
    }, [executeInvoiceQuery]);

    useEffect(() => {
        if (clientSearchTerm) {
            const newClientSearchOptions = _.cloneDeep(clientSearchOptions);
            newClientSearchOptions.clearFilters();
            newClientSearchOptions.addFilter(new ODataFilter('[cl_no]', ODataFilterOperators.Equals, clientSearchTerm));
            setClientSearchOptions(newClientSearchOptions);
        }
    }, [clientSearchTerm]);

    useEffect(() => {
        if (Array.isArray(igSubcodes) && igSubcodes.length > 0) {
            if (invoiceGroup && invoiceGroup.clientNumber && invoiceGroup.projectNumber) {
                const newInvoiceGroup = _.cloneDeep(invoiceGroup);
                newInvoiceGroup.prospectInvoiceGroup = igSubcodes.length + 1;
                setInvoiceGroup(newInvoiceGroup);
            }
        }
    }, [igSubcodes]);

    useEffect(() => {
        if (selectedFormat !== undefined) {
            // resetInvoiceSearchOptions();
            if (selectedFormat === null) {
                setSelectedFormat(undefined);
            }
        }
    }, [selectedFormat]);

    useEffect(() => {
        if (selectedOffice !== undefined) {
            if (selectedOffice === null) {
                setSelectedOffice(undefined);
            }
            // resetInvoiceSearchOptions();
        }
    }, [selectedOffice]);

    useEffect(() => {
        if (selectedSource !== undefined) {
            // resetInvoiceSearchOptions();
            if (selectedSource == null) {
                setSelectedSource(undefined);
            }
        }
    }, [selectedSource]);

    useEffect(() => {
        if (updatingDocument) {
            handleUpdateDocument();
        }
    }, [updatingDocument]);

    useEffect(() => {
        if (Array.isArray(creatingGroup)) {
            if (addSections) {
                const updateSections = normalizeInvoiceGroupSubcodes(_.cloneDeep(creatingGroup));
                setAddSections(false);
                updateInvoiceGroupSections(updateSections);
            }
        }
    }, [creatingGroup]);

    useEffect(() => {
        if (openInvoiceGrouping) {
            showDialog(DialogList.INVOICE_GROUPING);
        }
    }, [openInvoiceGrouping]);

    useEffect(() => {
        if (openGenerateIgDocs) {
            showDialog(DialogList.CONFIRM_GENERATE_IG_DOCS);
        }
    }, [openGenerateIgDocs]);

    useEffect(() => {
        if (invoiceGroupSubcodeSearchOptions && invoiceGroupSubcodeSearchOptions.hasFilters()) {
            getInvoiceGroupSubcodes();
        }
    }, [invoiceGroupSubcodeSearchOptions]);

    useEffect(() => {
        if (invoiceValidationData) {
            console.log(invoiceValidationData);
        }
    }, [invoiceValidationData]);

    useEffect(() => {
        if (!!selectedPayPeriod && selectedPayPeriod.length > 0) {
            localStorage.setItem('backOfficeSelectedPayPeriod', selectedPayPeriod);
            resetInvoiceSearchOptions();
        }
    }, [selectedPayPeriod]);

    useEffect(() => {
        if (!!payPeriodSearchOptions) {
            getPayPeriods();
        }
    }, [payPeriodSearchOptions]);

    useEffect(() => {
        if ((!!payPeriodSearchTerm || payPeriodSearchTerm === '') && !!payPeriodSearchOptions) {
            resetPayPeriodSearchOptions();
        }
    }, [payPeriodSearchTerm]);

    useEffect(() => {
        if (!generatingDocument && Array.isArray(invoices) && invoices.length > 0) {            
            hideIdDialogAndRefreshInvoiceList();
        }
    }, [generatingDocument]);

    useEffect(() => {
        if (!isGeneratingInvoices && Array.isArray(invoices) && invoices.length > 0) {
            getMasterInvoices();
        }
    }, [isGeneratingInvoices]);

    useEffect(() => {
        if (!isGeneratingDocuments) {
            setGeneratingDocument(false);
        }
    }, [isGeneratingDocuments]);

    useEffect(() => {
        if (selectedSubcode) {
            console.log('selectedSubcode: ' + selectedSubcode);
        }
    }, [selectedSubcode]);

    useEffect(() => {
        if (selectedGroupNumber !== undefined) {
            if (selectedGroupNumber === null) {
                setSelectedGroupNumber(undefined);
            }
            // resetInvoiceSearchOptions();
        }
    }, [selectedGroupNumber]);

    useEffect(() => {
        if (selectedTotal !== undefined) {
            // resetInvoiceSearchOptions();
            if (selectedTotal === null) {
                setSelectedTotal(undefined);
            }
        }
    }, [selectedTotal]);

    useEffect(() => {
        if (selectedCreatedByNumber !== undefined) {
            // resetInvoiceSearchOptions();
            if (selectedCreatedByNumber === null) {
                setSelectedCreatedByNumber(undefined);
            }
        }
    }, [selectedCreatedByNumber]);

    useEffect(() => {
        if (selectedAltSubcode) {
            resetInvoiceSearchOptions();
        }
    }, [selectedAltSubcode]);

/*     useEffect(() => {
        if (!!officeExpenseReceiptBlob) {
            generateOfficeExpenseReceiptDocument();
        }
    }, [officeExpenseReceiptBlob]); */

    useEffect(() => {
        if (!!expenseReceiptBlob) {
            generateExpenseReceiptDocument();
        }
    }, [expenseReceiptBlob]);

    useEffect(() => {
        if (openDocumentManagement) {
            manageDocuments();
        }
    }, [openDocumentManagement]);

    useEffect(() => {
        if (openInvoiceGroups) {
            dispatch(actions.layout.showDialog(DialogList.INVOICE_GROUPING));
        }
    }, [openInvoiceGroups]);

    useEffect(() => {
        if (!!openGenerateTimesheet) {
            dispatch(actions.layout.showDialog(DialogList.GENERATE_TIMESHEET));
        }
    }, [openGenerateTimesheet]);

    useEffect(() => {
        if (!!openArchiveReasonDialog) {
            handleUpdateDocument();
        }
    }, [openArchiveReasonDialog]);

    useEffect(() => {
        if (!!clientSearchOptions) {
            getClients();
        }
    }, [clientSearchOptions]);

    useEffect(() => {
        if ((!!invoiceSearchTerm || invoiceSearchTerm === '') && !!invoiceSearchOptions) {
            resetInvoiceSearchOptions();
        }
    }, [invoiceSearchTerm]);

    useEffect(() => {
        if (selectedInvoiceIndex !== undefined) {
            getInvoiceDetail();
        }
    }, [selectedInvoiceIndex]);

    useEffect(() => {
        if (!!invoiceSearchOptions) {
            const invoiceSearchFilters = invoiceSearchOptions.getFilters();
            if (!enableInvoiceMaster && Array.isArray(invoiceSearchFilters) &&  invoiceSearchFilters?.length === 0) {
                setEnableInvoiceMaster(true);
            } else if (enableInvoiceMaster) {
                getMasterInvoices();
            }
        }
    }, [invoiceSearchOptions]);

    useEffect(() => {
        if (!!clients && clients.length > 0) {
            prepFormData();
            const storedClientNumber = localStorage.getItem('backOfficeSelectedClientNumber');
            console.log(storedClientNumber);
            if (!!storedClientNumber && !isNaN(Number(storedClientNumber))) {
                const clientToSelect = clients.find((c) => c.clientNumber === Number(storedClientNumber));
                if (!!clientToSelect) {
                    setSelectedClient(clientToSelect);
                } else {
                    setSelectedClientNumber(!isNaN(Number(storedClientNumber)) ? Number(storedClientNumber) : undefined);
                }
                const storedProjectNumber = localStorage.getItem('backOfficeSelectedProjectNumber');
                if (storedProjectNumber && !isNaN(Number(storedProjectNumber))) {
                    const numericStoredProjectNumber = Number(storedProjectNumber);
                    if (!isNaN(numericStoredProjectNumber) && numericStoredProjectNumber !== 0) {
                        setSelectedProjectNumber(numericStoredProjectNumber);
                    }
                } else {
                    localStorage.removeItem('backOfficeSelectedProjectNumber');
                }

            }
        }
    }, [clients]);

    useEffect(() => {
        if (!!invoiceDocsForUpload && Array.isArray(invoiceDocsForUpload) && invoiceDocsForUpload.length > 0) {
            const invoiceNumber = invoiceDocsForUpload[0].invoiceNumber;
            mergeInvoiceDocuments(invoiceDocsForUpload, invoiceNumber ? invoiceNumber.toString() : '0');
            getMasterInvoices();
        }
    }, [invoiceDocsForUpload]);

    useEffect(() => {
        if (!!invoiceDocs && Array.isArray(invoiceDocs) && invoiceDocs.length > 0) {
            console.log(invoiceDocs);
        }
    }, [invoiceDocs]);

    useEffect(() => {
        if (!!invoices && invoices.length > 0) {
            const formData = getValues();
            reset(invoices);
            console.log(formData);
        }
        setLoadingInvoices(false);
    }, [invoices]);

    useEffect(() => {
        if (selectedClient && selectedClient.clientNumber && selectedClient.clientName) {
            localStorage.setItem('backOfficeSelectedClientNumber', selectedClient.clientNumber.toString());
            localStorage.setItem('backOfficeSelectedClientName', selectedClient.clientName);
        }
    }, [selectedClient]);

    useEffect(() => {
        if (selectedProject && selectedProject?.number && !isNaN(Number(selectedProject?.number))) {
            localStorage.setItem('backOfficeSelectedProjectNumber', selectedProject.number.toString());
            if (selectedProject?.name) {
                localStorage.setItem('backOfficeSelectedProjectName', selectedProject.name);
            }
        } else if (selectedProjectNumber && !isNaN(Number(selectedProjectNumber))) {
            localStorage.setItem('backOfficeSelectedProjectNumber', selectedProjectNumber.toString());
        }
    }, [selectedProjectNumber, selectedProject]);

    useEffect(() => {
        if (!isNaN(selectedClientNumber)) {
            setClientSearchTerm(selectedClientNumber.toString());
        }
    }, [selectedClientNumber]);

    useEffect(() => {
        if (Array.isArray(receiptThumbnails)) {
            setReceiptViewContext(1);
            showReceiptViewerDialog();
        }
    }, [receiptThumbnails]);

    useEffect(() => {
        if (Array.isArray(igCoverLetterBytes)) {
            setReceiptViewContext(2);
            showReceiptViewerDialog();
        }
    }, [igCoverLetterBytes]);

    useEffect(() => {
        if (!!invoiceThumbnails) {
            showReceiptViewerDialog();
        }
    }, [invoiceThumbnails]);

    const resetInvoiceGroupSubcodeSearchOptions = () => {
        let newInvoiceGroupSubcodeSearchOptions = _.cloneDeep(invoiceGroupSubcodeSearchOptions);
        newInvoiceGroupSubcodeSearchOptions.setIsNextpage(true);
        newInvoiceGroupSubcodeSearchOptions.clearFilters();
        newInvoiceGroupSubcodeSearchOptions.addPaging(1, 1000);
        newInvoiceGroupSubcodeSearchOptions.addFilter(new ODataFilter('igi.[cl_no]', ODataFilterOperators.Equals, '1387'));
        newInvoiceGroupSubcodeSearchOptions.addFilter(new ODataFilter('igi.[pr_no]', ODataFilterOperators.Equals, '2'));
        setInvoiceGroupSubcodeSearchOptions(newInvoiceGroupSubcodeSearchOptions);
    };

    const setSortDirection = (direction: boolean) => {
        sortDirection.current = direction;
    };

    const setTotalLike = (like: boolean) => {
        totalLike.current = like;
    };

    const setExcludePostedInvoices = (setExcluded: boolean) => {
        excludePostedInvoices.current = setExcluded;
    };

    const setExcludeUnPostedInvoices = (setExcluded: boolean) => {
        excludeUnPostedInvoices.current = setExcluded;
    };

    const setExcludeNonVoidInvoices = (setExcluded: boolean) => {
        excludeNonVoidInvoices.current = setExcluded;
    };

    const setExcludeVoidInvoices = (setExcluded: boolean) => {
        excludeVoidInvoices.current = setExcluded;
    };

    const getOfficeExpenseReceiptsThumbnails = async () => {
        // Todo: get the office expense receipts from the invoice context
        const officeExpenseId = 1076080;
        if (!!officeExpenseId) {
            let result = await get(`/v1.0/AccountsPayable/receipts/expense/${officeExpenseId}/receipts/thumbnails`);

            if (response.ok && result?.length > 0) {
                setReceiptThumbnails(result);
            } else {
                console.log('Unable to get office expense receipt thumbnail data!!!');
            }
        }
    };

    const getInvoiceThumbnails = async () => {
        const invoiceList = (getValues().invoices as Array<Invoice>);
        const payload = new Array<InvoiceDoc>();
        const selectedInvoiceList = invoiceList
        .map((i, index) => (i.selection === true ? invoices[index] : null))
        .filter((x): x is NonNullable<typeof x> => x !== null);

        for (const iv of selectedInvoiceList) {
            const doc = iv.documents.find(i => i.documentType === 'INVOICE');
            if (doc) {
                payload.push(doc);
            }
        }
        let result = await post(`/v1.0/AccountsPayable/invoices/thumbnails`, payload);

        if (response.ok && result?.length > 0) {
            setInvoiceThumbnails(result);
        } else {
            console.log('Unable to get invoice thumbnail data!!!');
        }
    };

    const preparePayloadForInvoiceGeneration = (payload: InvoiceGeneration) => {
        const preparedPayload = new InvoiceGeneration();
        preparedPayload.createdByNumber = tsdiNumber;
        preparedPayload.createdByName = appContext.currentUser.username;
        preparedPayload.clientNumber = Number(payload.clientNumber) === 0 ? null : Number(payload.clientNumber);
        preparedPayload.projectNumber = Number(payload.projectNumber) === 0 ? null : Number(payload.projectNumber);
        preparedPayload.subcode = Number(payload.subcode) === 0 ? null : Number(payload.subcode);
        preparedPayload.altSubcode = Number(payload.altSubcode) === 0 ? null : Number(payload.altSubcode);
        preparedPayload.office = payload.office;
        preparedPayload.assignedBackup = Number(payload.assignedBackup);
        preparedPayload.backupRate = Number(payload.backupRate);
        preparedPayload.backupPercentage = payload.backupPercentage ? payload.backupPercentage : null;
        preparedPayload.periodType = Number(payload.periodType);
        preparedPayload.startDate = payload.startDate;
        preparedPayload.endDate = payload.endDate;
        preparedPayload.invoiceDate = payload.invoiceDate;
        generateInvoices(preparedPayload);
    };

    const generateInvoiceDocuments = async (options: ODataOptions, payload: Array<number>) => {
        setGeneratingDocument(true);
        dispatch(actions.layout.setGeneratingDocuments(true));
        const queryString = options.toString();
        await post(`/v1.0/AccountsPayable/invoices/documents/generate${queryString}`, payload);

        if (response.status !== 202) {
            setGeneratingDocument(false);
            dispatch(actions.layout.setGeneratingDocuments(false));
            console.log('Unable to generate invoices!');
        }
    };

    const getZipArchivedDocuments = async (payload: Array<InvoiceDoc>) => {
        dispatch(actions.layout.setGeneratingZip(true));
        await post(`/v1.0/AccountsPayable/invoice/documents/zipfile`, payload);
        if (response.status !== 202) {
            dispatch(actions.layout.setGeneratingZip(false));
            console.log('Unable to start zip archive generation!');
        }
    };

/*     const getZipArchivedDocumentsLegacy = async (payload: Array<InvoiceDoc>) => {
        try {
            const result = await postBinary(`/AccountsPayable/invoice/documents/zipfile/legacy`, payload);

            if (responseBinary.ok && result?.byteLength > 0) {
                const zipFileBytes: Uint8Array = result;
                const zipFileBlob = new Blob([zipFileBytes], { type: 'application/zip' });

                if (!zipFileBlob || zipFileBlob.type !== 'application/zip') {
                    console.log('Unexpected file response:', zipFileBlob);
                    return;
                }
    
                const url = window.URL.createObjectURL(zipFileBlob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `InvoiceDocuments_Archive_${new Date().toISOString().split('T')[0]}.zip`);
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(url);
            } else {
                console.log('Unable to get office expense receipt pdf binary data!!!');
            }
        } catch (error) {
            console.log('Download failed:', error);
        }
    };
 */
    const generateInvoices = async (payload: InvoiceGeneration) => {
        dispatch(actions.layout.setGeneratingInvoices(true));
        await post(`/v1.0/AccountsPayable/invoices/generate`, payload);

        if (response.status !== 202) {
            dispatch(actions.layout.setGeneratingInvoices(false));
            console.log('Unable to generate invoices!');
        }
    };

    const showReceiptViewerDialog = () => {
        showDialog(DialogList.RECEIPT_VIEWER);
    };

    const onCreate = () => {
        // Put all initialization code here.
        reset(); // Reset form values so they can be controlled
        initializeClientSearchSettings();
        initializeInvoiceSearchSettings();
        initializePayPeriodSearchSettings();
        resetInvoiceGroupSubcodeSearchOptions();
        getInvoiceDocumentTypes();
        getInvoiceDetailTypes();
        getUser();
        getOffices();
    };

    const onDestroy = () => {
        // Put all destruction code here.
    };

/*     const generateOfficeExpenseReceiptDocument = async () => {
        handleCreateDocument(3, '326445', officeExpenseReceiptBlob);
    }; */

    const generateExpenseReceiptDocument = async () => {
        handleCreateDocument(3, '326449', expenseReceiptBlob);
    };

/*     const getTimePeriodNumber = (endDate: Date): number => {
        const newEndDate = new Date(endDate);
        const year = newEndDate.getFullYear();
        const month = newEndDate.getMonth();
        const day = newEndDate.getDate();
    
        // Each month has 2 periods: (month * 2) + (1 for first half, 2 for second half)
        const half = day < 16 ? 1 : 2; 
        const period = month * 2 + half;
    
        // Ensure period is always 2 digits (01–24)
        const periodString = period.toString().padStart(2, '0');
    
        return Number(`${year}${periodString}`);
    };  */    

    const handleGenerateTimesheet = (invoiceIndex: number, hasDocument: boolean) => {
        // const invoiceNumberString = !!invoices && invoices.length > invoiceIndex ? invoices[invoiceIndex]?.number : null;
        // const invoiceNumber = !isNaN(Number(invoiceNumberString)) ? Number(invoiceNumberString) : 0;
        if (!hasDocument) {
            generateTimesheet();
        } /* else {
            const timePeriod = 202502;
            const employeeId = 204;
            getInvoiceDocument(timePeriod, employeeId, invoiceNumber, 2);
        } */
    };

    const handleGenerateTimesheetDocument = (payload: TimeSheet, backup: boolean) => {
        if (!backup) {
            handleGenerateTimesheetForInvoice(payload);
        } else {
            handleGenerateBackupTimesheetForInvoice();
        }
    };

    const handleGenerateTimesheetForInvoice = (payload: TimeSheet) => {
        const invoiceNumberString = !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : null;
        const invoiceNumber = !isNaN(Number(invoiceNumberString)) ? Number(invoiceNumberString) : 0;
        const documentSettings = {
            clientNumber: payload.clientNumber.toString(),
            projectNumber: payload.projectNumber.toString(),
            subcode: payload.subcode.toString(),
            altSubcode: payload.altSubcode.toString(),
            expense: payload.expense,
            recap: payload.recap,
            omitServices: payload.omitServices,
            generateInvoiceDetail: payload.invoiceDetail,
            invoiceNumber: invoiceNumber
        };
        if (!hasTimeSheet(selectedInvoiceIndex)) {
            setGeneratingDocument(true);
            const beginDate =
                payload.beginDate instanceof Date
                    ? payload.beginDate
                    : new Date(payload.beginDate + 'T00:00:00');

            const beginDateString = beginDate.toLocaleDateString();
            const endDate =
                payload.endDate instanceof Date
                    ? payload.endDate
                    : new Date(payload.endDate + 'T00:00:00');

            const endDateString = endDate.toLocaleDateString();
            getTimesheetReportFileForEmployeeNumber(
                2,
                beginDateString,
                endDateString,
                payload.employeeNumber.toString(),
                documentSettings);
        } /* else {
            const timePeriod = 202502;
            const employeeId = 204;
            getInvoiceDocument(timePeriod, employeeId, invoiceNumber, 2);
        } */
    };

    const handleGenerateBackupTimesheetForInvoice = () => {
        const invoiceNumberString = !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : null;
        const invoiceNumber = !isNaN(Number(invoiceNumberString)) ? Number(invoiceNumberString) : 0;
        if (!hasBop(selectedInvoiceIndex)) {
            setGeneratingDocument(true);
            getBackupTimesheetReportFile(2, invoiceNumber?.toString());
        }
    };

/*     const handleGenerateOfficeExpensesDocument = () => {
        const payPeriod = 202502;
        const invoiceNumber = (!!invoices && selectedInvoiceIndex < invoices.length) ? invoices[selectedInvoiceIndex].number : '0';
        getOfficeExpensesReportFile(2, payPeriod, invoiceNumber);
    }; 

    const handleGenerateOfficeExpenseReceiptDocument = () => {
        getOfficeExpenseReceipt(1076080, 10300);
    };*/

    const handleGetBaseCsvFile = (invoiceNumber: string) => {
        getBaseCsvFile(invoiceNumber);
    };

/*     const getInvoiceDocument = async (
        timePeriod: number,
        employeeId: number,
        invoiceNumber: number,
        documentType: number
    ) => {
        const url = `/v1.0/AccountsPayable/invoice/${invoiceNumber}/document/timeperiod/${timePeriod}/employeeid/${employeeId}/doctype/${documentType}`;
        let result = await get(url);

        if (response.ok) {
            setInvoiceDocument(result);
        } else {
            console.log('Unable to get invoice document!');
        }
    }; */

    const getInvoiceDocs = async (invoiceNumber: number, forUpload: boolean = false) => {
        let result = await get(`/v1.0/AccountsPayable/invoice/${invoiceNumber}/documents`);

        if (response.ok) {
            if (!forUpload) {
                setInvoiceDocs(result);
            } else {
                setInvoiceDocsForUpload(result);
            }
        } else {
            console.log('Unable to get invoice documents!');
        }
    };

    const getInvoiceGroupDocs = async (invoiceGroupNumber: number) => {
        let result = await get(`/v1.0/AccountsPayable/invoice/groups/${invoiceGroupNumber}/documents`);

        if (response.ok) {
            setInvoiceGroupDocs(result);
        } else {
            console.log('Unable to get invoice documents!');
        }
    };

    const getArchivedInvoiceDocs = async (invoiceNumber: number, forUpload: boolean = false) => {
        let result = await get(`/v1.0/AccountsPayable/invoice/${invoiceNumber}/archivedocuments`);

        if (response.ok) {
            if (!forUpload) {
                setArchivedInvoiceDocs(result);
            } else {
                setInvoiceDocsForUpload(result);
            }
        } else {
            console.log('Unable to get archived invoice documents!');
        }
    };

    const getArchivedInvoiceGroupDocs = async (invoiceGroupNumber: number, forUpload: boolean = false) => {
        let result = await get(`/v1.0/AccountsPayable/invoice/group/${invoiceGroupNumber}/archivedocuments`);

        if (response.ok) {
            if (!forUpload) {
                setArchivedInvoiceDocs(result);
            } else {
                setInvoiceDocsForUpload(result);
            }
        } else {
            console.log('Unable to get archived invoice documents!');
        }
    };

    const getTimesheetReportFileForEmployeeNumber = async (outputType: number, startDate: string, endDate: string, employeeNumber: string, settings: InvoiceDocument) => {
        if (startDate && endDate && employeeNumber) {
            const payPeriod = selectedPayPeriod ? selectedPayPeriod : 202504;
            const params = new URLSearchParams({
                payPeriod: null,
                reportFormat: outputType.toString(),
                tsdiNumber: employeeNumber,
                beginDate: startDate,
                endDate: endDate,
                clientNumber: settings.clientNumber,
                projectNumber: settings.projectNumber,
                subcode: settings.subcode,
                altSubcode: settings.altSubcode,
                omitServices: settings.omitServices ? 'true' : 'false',
                expenses: settings.expense ? 'true' : 'false',
                generateInvoiceDetail: settings.generateInvoiceDetail ? 'true' : 'false',
                invoiceNumber: settings.invoiceNumber.toString()
            });
            await get(`v1.0/reports/GetReport/${outputType}/timeAndExpenseSheet/payperiod/${payPeriod}/employeeNumber/${employeeNumber}?${params}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    uploadInvoiceDocPdf(blob, 'TIMESHEET', settings.invoiceNumber.toString());
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `${new Date(startDate).toISOString().split('T')[0]}-${new Date(endDate).toISOString().split('T')[0]}-${settings.invoiceNumber}_Timesheet.xlsx` :
                     `${new Date(startDate).toISOString().split('T')[0]}-${new Date(endDate).toISOString().split('T')[0]}-${settings.invoiceNumber}_Timesheet.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    };

    const getTimesheetReportFile = async (outputType: number, timePeriod: number, invoiceNumber: string) => {
        if (!!timePeriod && !!invoiceNumber) {
            await get(`v1.0/reports/GetReport/${outputType}/timesheet/timeperiod/${timePeriod}/invoiceNumber/${invoiceNumber}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    uploadInvoiceDocPdf(blob, 'TIMESHEET', invoiceNumber);
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `${timePeriod}-${invoiceNumber}-Timesheet.xlsx` : `${timePeriod}-${invoiceNumber}-Timesheet.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    };

    const getInvoiceReportFile = async (outputType: number, invoiceNumber: string) => {
        if (invoiceNumber) {
            await get(`v1.0/reports/GetReport/${outputType}/Invoices/invoiceNumber/${invoiceNumber}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    uploadInvoiceDocPdf(blob, 'INVOICE', invoiceNumber);
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `${invoiceNumber}-Invoice.xlsx` : `${invoiceNumber}-Invoice.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    };

/*     const getInvoiceListFile = async (beginDate: Date, endDate: Date) => {
        if (!!beginDate && !!endDate) {
            await get(`v1.0/reports/GetReport/${1}/invoicelist/beginDate/${beginDate.toISOString().split('T')[0]}/endDate/${endDate.toISOString().split('T')[0]}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    const a = document.createElement('a');
                    a.href = URL.createObjectURL(blob);
                    a.download = `${beginDate.toISOString().split('T')[0]}_${endDate.toISOString().split('T')[0]}-InvoiceList.xlsx`;
                    a.click();
                    window.URL.revokeObjectURL(a.href);
                });
            }
        } else {
            alert('No Invoices in that time period!');
        }
    }; */

    const getBackupTimesheetReportFile = async (outputType: number, invoiceNumber: string) => {
        if (!!invoiceNumber) {
            await get(`v1.0/reports/GetReport/${outputType}/backuptimesheet/invoiceNumber/${invoiceNumber}`);
            if (response.ok && response.status !== 204) {
                await response.blob().then((blob) => {
                    uploadInvoiceDocPdf(blob, 'BOPTS', invoiceNumber);
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `$${invoiceNumber}-BackupTimesheet.xlsx` : `${invoiceNumber}-BackupTimesheet.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            } else if (response.status === 204) {
                alert('No BOP time present for Invoice # ' + invoiceNumber + '.');
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    };

    const getBaseCsvFile = async (invoiceNumber: string, returnBlob: boolean = false) => {
        if (!invoiceNumber) {
            return null;
        }

        await get(`v1.0/AccountsPayable/invoice/csv`);

        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();

        if (!returnBlob) {
            handleCreateDocument(5, invoiceNumber, blob);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.getElementById('baseCsvFile') as HTMLAnchorElement;
            a.href = blobUrl;
            a.download = `Invoice-${invoiceNumber}.csv`;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            return null; // Nothing to return when downloading
        }

        // Return the blob when requested
        return blob;
    };

    const handleGetIgSupplierLinkCsv = async (invoiceGroupNumber: string) => {
        return await getInvoiceGroupCsvFile(invoiceGroupNumber);
    };

    const handleGetSupplierLinkCsv = async (csvData: InvoiceGeneration) => {
        return await getSupplierLinkCsvFile(csvData);
    };

    const handleOpenSupplierLinkCsvDialog = () => {
        showDialog(DialogList.GENERATE_SUPPLIER_LINK_CSV);
    };

    const getInvoiceGroupCsvFile = async (invoiceGroupNumber: string, returnBlob: boolean = false) => {
        if (!invoiceGroupNumber) {
            return null;
        }

        await get(`v1.0/AccountsPayable/invoice/group/${invoiceGroupNumber}/csv`);

        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();

        if (!returnBlob) {
            // handleCreateDocument(5, invoiceNumber, blob);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = `SupplierLink_Invoice-${invoiceGroupNumber}.csv`;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            return null; // Nothing to return when downloading
        }

        // Return the blob when requested
        return blob;
    };

    const getSupplierLinkCsvFile = async (csvData: InvoiceGeneration, returnBlob: boolean = false) => {
        if (!csvData) {
            return null;
        }

        const params = new URLSearchParams({
            clientNumber: csvData.clientNumber.toString(),
            projectNumber: csvData.projectNumber ? csvData.projectNumber.toString() : '0',
            beginDate: new Date(csvData.startDate).toLocaleDateString(),
            endDate: new Date(csvData.endDate).toLocaleDateString(),
            office: officeOptionValues.find((o, index) => index - 1 === Number(csvData.office)).label
        });

        await get(`v1.0/AccountsPayable/invoices/supplierlink/csv?${params}`);

        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();

        if (!returnBlob) {
            // handleCreateDocument(5, invoiceNumber, blob);
            const blobUrl = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = blobUrl;
            a.click();
            window.URL.revokeObjectURL(blobUrl);
            return null; // Nothing to return when downloading
        }

        // Return the blob when requested
        return blob;
    };

    const getInvoiceDetailTypes = async () => {
        const result = await get(`v1.0/AccountsPayable/invoice/detail/types`);
        if (response.ok) {
            setInvoiceDetailTypes(result);
        } else {
            console.log('Unable to get invoice types.');
        }
    };

    const getInvoiceDocumentTypes = async () => {
        const result = await get(`v1.0/AccountsPayable/invoice/documents/types`);
        if (response.ok) {
            setInvoiceTypes(result);
        } else {
            console.log('Unable to get invoice types.');
        }
    };

/*     const getOfficeExpensesReportFile = async (outputType: number, timePeriod: number, invoiceNumber: string) => {
        if (!!timePeriod && !!invoiceNumber) {
            await get(`v1.0/reports/GetReport/${outputType}/officeExpenses/timeperiod/${timePeriod}/invoiceNumber/${invoiceNumber}`);
            if (response.ok) {
                await response.blob().then((blob) => {
                    uploadInvoiceDocPdf(blob, 'OFFEXP', invoiceNumber);
                    const blobUrl = window.URL.createObjectURL(blob);
                    const a = document.getElementById('timesheetReport') as HTMLAnchorElement;
                    a.href = blobUrl;
                    a.download = outputType === 1 ? `${timePeriod}-${invoiceNumber}-OfficeExpenses.xlsx` : `${timePeriod}-${invoiceNumber}-OfficeExpenses.pdf`;
                    a.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }
        } else {
            alert('No time period and/or employeeId selected!');
        }
    }; 

    const getTimesheetReportFileBytes = async (
        outputType: number,
        timePeriod: number,
        invoiceNumber: number
      ): Promise<Blob | null> => {
        if (!timePeriod || !invoiceNumber) {
          alert('No time period and/or invoice number selected!');
          return null;
        }
      
        const result = await get(
          `v1.0/reports/GetReport/${outputType}/timesheet/timeperiod/${timePeriod}/invoiceNumber/${invoiceNumber}`
        );
      
        if (result && response.ok) {
          const blob = await response.blob();
          return blob; // ✅ returns Blob
        }
      
        console.log('Unable to fetch timesheet report file!');
        return null; // ✅ ensures all code paths return
    };*/

    const getClients = async () => {
        const queryString = clientSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/clients${queryString}`);

        if (response.ok) {
            setClients([]);
            setClients(result.items);
            // Todo: get this from the DB and set it when the client is set from FindClientsDialog
        } else {
            setClients([]);
            console.log('Unable to get client data!');
        }
    };

    const getOffices = async () => {
        let result = await get(`/v1.0/AccountsPayable/billing/offices`);

        if (response.ok) {
            setOffices([]);
            setOffices(result);
        } else {
            setOffices([]);
            console.log('Unable to get TSDI Office data!');
        }
    };

    const GenerateInvoices = () => {
        dispatch(actions.layout.showDialog(DialogList.GENERATE_INVOICES));
    };

    const onGenerateInvoices = (payload: object) => {
        preparePayloadForInvoiceGeneration(payload);
        hideDialog();
    };
/* 
    const getOfficeExpenseReceipt = async (officeExpenseId: number, officeExpenseReceiptId: number) => {
        let result = await getBinary(`/AccountsPayable/receipts/expense/${officeExpenseId}/receipt/${officeExpenseReceiptId}`);

        if (responseBinary.ok && result?.byteLength > 0) {
            const pdfbytes: Uint8Array = result;
            const pdfBlob = new Blob([pdfbytes], { type: 'application/pdf' });
            setOfficeExpenseReceiptBlob(pdfBlob);
        } else {
            console.log('Unable to get office expense receipt pdf binary data!!!');
        }
    };

    const getExpenseReceiptForInvoice = async (invoiceNumber: number) => {
        let result = await getBinary(`/AccountsPayable/receipt/expense/invoice/${invoiceNumber}`);

        if (responseBinary.ok && result?.byteLength > 0) {
            const pdfbytes: Uint8Array = result;
            const pdfBlob = new Blob([pdfbytes], { type: 'application/pdf' });
            setExpenseReceiptBlob(pdfBlob);
        } else {
            console.log('Unable to get T&E expense receipt pdf binary data!!!');
        }
    }; */

    const validateManualInvoice = async (payload: { clientNumber: number,
                                                    projectNumber: number,
                                                    subcode: string,
                                                    altSubcode: string,
                                                    office: string,
                                                    beginDate: Date,
                                                    endDate: Date,
                                                    invoiceDate: Date}
                                        ) => {
        const result = await validateBillingCode(payload.clientNumber, payload.projectNumber, payload.subcode, payload.altSubcode);
        const validationPayload = new Invoice();
        validationPayload.clientNumber = payload.clientNumber.toString();
        validationPayload.projectNumber = payload.projectNumber.toString();
        validationPayload.subCode = payload.subcode ? payload.subcode.toString() : null;
        validationPayload.altSubcode = payload.altSubcode ? payload.altSubcode.toString() : null;
        validationPayload.altSubcode = payload.altSubcode ? payload.altSubcode.toString() : null;
        validationPayload.beginDate = payload.beginDate ? payload.beginDate : null;
        validationPayload.endDate = payload.endDate ? payload.endDate : null;
        validationPayload.invoiceDate = payload.invoiceDate ? payload.invoiceDate : null;
        const validationResult = await validateManualInvoicePayload(validationPayload);
        const projectOffice = offices.find(o => o?.id === Number(payload?.office))?.office;
        const validationMessage = validationResult?.message.split('|');
        if (Array.isArray(validationMessage) && validationMessage.length > 1) {
            return { isValid: false, fieldErrors: { validationMessage: validationMessage[1], validationCode: validationMessage[0]} };
        }
        if (projectOffice !== validationResult.office) {
            return { isValid: false, fieldErrors: { office: 'Project office should be ' + validationResult.office + '.',  officeString: validationResult.office} };
        }
        if (!(result as { prospectName: string })?.prospectName) {
            return { isValid: false, fieldErrors: { clientNumber: 'Invalid prospect.'} };
        } else if ((result as { isSectionRequired: string }).isSectionRequired && !payload.subcode) {
            return { isValid: false, fieldErrors: { subcode: 'Subcode required.'} };
        } else if (!selectedPayPeriod) {
            return { isValid: false, fieldErrors: { payPeriod: 'No pay period selected.'} };
        } else {
            const sectionResult = await validateSection(
                { clientNumber: payload.clientNumber,
                  prospectNumber: payload.projectNumber,
                  sectionNumber: payload.subcode,
                  unitNumber: payload.altSubcode
                },
                selectedPayPeriod
            );
            const errorResult = (sectionResult as ErrorResponse);
            if (!errorResult?.isError) {
                return { isValid: true };
            } else {                
                return { isValid: false, fieldErrors: { subcode: errorResult.message} };
            }
        }
    };

    const getExpenseReceiptsForInvoice = async (invoiceNumber: number, isManual: boolean) => {
        const params = new URLSearchParams({
            isManual: isManual ? 'true' : 'false'
        });
        let result = await getBinary(`/AccountsPayable/receipts/expense/invoice/${invoiceNumber}?${params}`);

        if (responseBinary.ok && result?.byteLength > 0) {
            const pdfbytes: Uint8Array = result;
            const pdfBlob = new Blob([pdfbytes], { type: 'application/pdf' });
            setExpenseReceiptBlob(pdfBlob);
        } else {
            console.log('Unable to get T&E expense receipt pdf binary data!!!');
        }
    };

    const getMasterInvoices = async () => {
        setLoadingInvoices(true);
        const queryString = invoiceSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/master/invoices${queryString}`);

        if (response.ok && result?.length > 0) {
            setInvoices(result);
        } else {
            setInvoices([]);
            console.log('Unable to get Invoice Data!!!');
        }
    };

    const getInvoiceDetail = async (invoiceNumber: string = null) => {
        invoiceNumber = invoiceNumber ? invoiceNumber : (!!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : '0');
        if (!!invoiceNumber) {
            let result = await get(`/v1.0/AccountsPayable/invoice/${invoiceNumber}/detail`);

            if (response.ok && result?.length > 0) {
                setInvoiceDetail(result);
            } else {
                console.log('Unable to get Invoice detail data!!!');
            }
        }
    };

    const validateManualInvoicePayload = async (payload: Invoice) => {        
        if (!!Invoice) {
            let result = await post(`/v1.0/AccountsPayable/invoice/create/validate`, payload);

            if (response.ok && result) {
                setInvoiceValidationData(result);
            } else {
                console.log('Unable to validate Invoice!');
            }
            return result;
        }
    };

    const deleteInvoiceDetail = async (invoiceNumber: number, index: number) => {
        if (!isNaN(invoiceNumber) && !isNaN(index)) {
            let result = await del(`/v1.0/AccountsPayable/invoice/${invoiceNumber}/index/${index}detail`);

            if (response.ok && result === 1) {
                setInvoiceValidationData(result);
            } else {
                console.log('Unable to delete Invoice Detail!');
            }
            return result;
        }
    };

    const handleVoidOrArchive = (invoiceNumber: string, reason: string) => {
        if (!updatingDocument) {
            voidInvoice(invoiceNumber, reason);
        } else {
            // archive the document to be updated or deleted
            const invoice = invoices.find((i) => i.number === invoiceNumber);
            if (invoice && Array.isArray(invoice?.documents)) {
                const updateDoc = invoice.documents.find((d) => d.id === updatingDocument.docId);
                if (updateDoc) {
                    // upload the existing doc to S3 with a new key and add a row to INVOICE_DOCS_ARCHIVE
                    // if, this is Add or Update, upload the new doc to S3 with the same S3Key as the original
                    updateDoc.archiveAction = updatingDocument.archiveAction;
                    updateDoc.archiveReason = reason;
                    updateDoc.archivedBy = tsdiName;
                    updateDoc.archivedDate = new Date();
                    updateInvoiceDocument(updateDoc);
                    // relaunch the document management dialog
                    hideDialogAndOpenDocumentManagement();
                }
                setUpdatingDocument(null);
            } else {
                if (igNumber && Array.isArray(invoiceGroupDocs) && invoiceGroupDocs?.length > 0) {
                    const updateDoc = invoiceGroupDocs.find((d) => d.id === updatingDocument.docId);
                    if (updateDoc) {
                        updateDoc.archiveAction = updatingDocument.archiveAction;
                        updateDoc.archiveReason = reason;
                        updateDoc.archivedBy = tsdiName;
                        updateDoc.archivedDate = new Date();
                        updateInvoiceDocument(updateDoc);
                        hideDialogAndOpenDocumentManagement();
                    }
                    setUpdatingDocument(null);
                    setIgNumber(undefined);
                }
            }
        }
    };

    const voidInvoice = (invoiceNumber: string, reason: string) => {
        if (invoices && Array.isArray(invoices) && invoices.length > 0) {
            const payload = invoices.find(i => i?.number === invoiceNumber);
            if (payload) {
                payload.voided = true;
                payload.voidReason = reason;
                payload.updatedByName = tsdiName;
                payload.updatedByNumber = tsdiNumber.toString();
                updateInvoiceMaster(payload);
            }
        }
    };

    const updateInvoiceMaster = async (payload: Invoice) => {
        let result = await put(`/v1.0/AccountsPayable/invoice/master`, payload);

        if (response.ok && result > 0) {
            getMasterInvoices();
        } else {
            console.log('Unable to update all Invoice data!');
        }
    };

    const updateInvoiceGroup = async (payload: TsdiInvoiceGroup) => {
        let result = await put(`/v1.0/AccountsPayable/invoice/group`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to update Invoice Group data!');
        }
    };

    const getTypedValue = <T, K extends keyof T>(obj: T, key: K): T[K] => {
        return obj[key];
    };

    const setTypedValue = <T, K extends keyof T>(obj: T, key: K, value: T[K]): void => {
        obj[key] = value;
    };

    const sanitizeInvoiceGroupRequest = (
        payload: Partial<TsdiInvoiceGroupRequest>
    ): TsdiInvoiceGroupRequest => {
        const result = new TsdiInvoiceGroupRequest();

        for (const key of Object.keys(payload) as (keyof TsdiInvoiceGroupRequest)[]) {
        const value = getTypedValue(payload, key);
        const type = TsdiInvoiceGroupRequest.propertyTypes[key];

        switch (type) {
            case 'number':
                setTypedValue(
                result,
                key,
                value !== undefined && value !== null
                    ? Number(value)
                    : null
                    );
                break;

            case 'date':
                setTypedValue(
                result,
                key,
                value !== undefined && value !== null
                    ? new Date(value)
                    : null
                );
                break;
            default:
                setTypedValue(
                result,
                key,
                value !== undefined && value !== null && String(value).trim() !== ''
                    ? String(value)
                    : null
                );
                break;
            }
        }

        return result;
    };

    const mergeInvoiceGroupRequestProps = <
        K extends readonly (keyof TsdiInvoiceGroupRequest)[]
    >(
        obj1: TsdiInvoiceGroupRequest,
        obj2: TsdiInvoiceGroupRequest,
        keys: K
        ): TsdiInvoiceGroupRequest => {
        const result: TsdiInvoiceGroupRequest = { ...obj2 };

        for (const key of keys) {
            setTypedValue(result, key, obj1[key]);
        }

        return result;
    };

    const prepareUpdateInvoiceGroupRequest = async (payload: TsdiInvoiceGroupRequest) => {
        const invoiceRequest = invoiceGroupRequests.find((i) => i.groupIrNumber === Number(payload.groupIrNumber));
        if (invoiceRequest) {
            const merged = mergeInvoiceGroupRequestProps(
                invoiceRequest,
                payload,
                [
                    'groupId',
                    'closedByNumber',
                    'closedByName',
                    'closeRequestDate',
                    'closeDate',
                    'beginDate',
                    'endDate'
                ] as const
            );
            updateInvoiceGroupRequest(merged);
        } else {
            return;
        }
    };

    const updateInvoiceGroupRequest = async (payload: TsdiInvoiceGroupRequest) => {
        const sanitizedPayload = sanitizeInvoiceGroupRequest(payload);
        let result = await put(`/v1.0/AccountsPayable/invoice/group/request`, sanitizedPayload);

        if (response.ok && result < 1) {
            console.log('Unable to update Invoice GroupRequest data!');
        }
    };

    const generateInvoiceGroupDocuments = async (groupNumber: number) => {
        let result = await post(`/v1.0/AccountsPayable/invoice/group/${groupNumber}/documents/generate`);

        if (response.ok && result < 1) {
            console.log('Unable to Generate Invoice Group documents!');
        }
    };

    const createInvoiceGroup = async (payload: TsdiInvoiceGroup) => {
        let result = await post(`/v1.0/AccountsPayable/invoice/group/create`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to create Invoice Group data!');
        }
    };

    const updateInvoiceDetail = async (
        payload: InvoiceDetail[],
        formData: InvoiceDetail[]
    ) => {
        const invoiceNumber = Array.isArray(invoices) && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].number : null;
        const numericInvoiceNumber = invoiceNumber && !isNaN(Number(invoiceNumber)) ? Number(invoiceNumber) : null;

        if (!numericInvoiceNumber) {
            return;
        }
        const originalDetails = invoices[selectedInvoiceIndex].details;

        // 1) Update existing rows
        const updatedDetails: InvoiceDetail[] = originalDetails
            .map((row) => {
                //
                // 1a. Find matching dirty row
                //
                const dirtyRow = payload.find((p) => {
                    const ord = p.orderNumber;
                    if (ord.toString() === '' || ord === null || ord === undefined) {
                        return false;
                    }
                    return Number(ord) === row.orderNumber;
                });

                if (!dirtyRow) {
                    return null;
                }

                //
                // 1b. Find matching form row
                //
                const formRow = formData.find((f) => {
                    const ord = f.orderNumber;
                    if (ord.toString() === '' || ord === null || ord === undefined) {
                        return false;
                    }
                    return Number(ord) === row.orderNumber;
                });

                if (!formRow) {
                    return null;
                }

                //
                // 1c. Clone original row
                //
                const newRow: InvoiceDetail = { ...row };

                //
                // 1d. Apply dirty fields
                //
                Object.keys(dirtyRow).forEach((key) => {
                    const currentValue = newRow[key];
                    let formValue = formRow[key];

                    // Convert empty strings → null
                    if (typeof formValue === 'string' && formValue.length === 0) {
                        formValue = null;
                    }

                    // Preserve numeric type where appropriate
                    newRow[key] =
                        typeof currentValue === 'number'
                            ? (key === 'orderNumber' && formValue === '') ? formValue : Number(formValue)
                            : formValue;
                });

                return newRow;
            })
            .filter((row): row is InvoiceDetail => row !== null);

        // 2) Detect new rows from payload (orderNumber === '')
        const newRows = payload.filter((p) => p.orderNumber.toString() === '' || p.orderNumber === null || p.orderNumber === undefined)
        .map((nr) => {
            const newRow: InvoiceDetail = { ...nr, orderNumber: null, quantity: nr?.quantity?.toString() === '' ?
                null : Number(nr.quantity), rate: nr?.rate?.toString() === '' ? null : Number(nr.rate), amount: nr?.amount?.toString() === '' ?
                    null : Number(nr.amount), invNumber: numericInvoiceNumber };
            return newRow;
        });

        // 3) Append new rows to updatedDetails
        const finalPayload = [...updatedDetails, ...newRows];

        //
        // 4) Save changes
        //
        if (Array.isArray(finalPayload) && finalPayload.length > 0) {
            const result = await put(
                `/v1.0/AccountsPayable/invoice/detail`,
                finalPayload
            );

            if (response.ok && result > 0) {
                getMasterInvoices();
            } else {
                console.log('Unable to update all Invoice detail data!');
            }
        }
    };

    const upsertInvoiceDetail = async (newHeader: string) => {
        const invoiceNumber = !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : 0;
        const payload = new InvoiceDetail();
        payload.header = newHeader;
        if (!!invoiceNumber) {
            let result = await post(`/v1.0/AccountsPayable/invoice/${invoiceNumber}/header`, payload);
            if (response.ok && result > 1) {
                getMasterInvoices();
                getInvoiceDetail();
            } else {
                console.log('Unable to update Invoice header data!');
            }
        }
    };

    const selectAllInvoices = () => {
        setAllInvoicesSelectedOrDeselected(true);
    };

    const deselectAllInvoices = () => {
        setAllInvoicesSelectedOrDeselected(false);
    };

    const openWindowsBreakdownDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.INVOICE_BREAKDOWN));
    };

    const showInvoiceDetailsDialog = () => {
        dispatch(actions.layout.showDialog(DialogList.INVOICE_DETAILS));
    };

    const createManualInvoice = () => {
        dispatch(actions.layout.showDialog(DialogList.CREATE_MANUAL_INVOICE));
    };

    const getPayPeriodAsNumber = (period: string) => {
        const periodNumberString = payPeriods.find((pp) => {
            return pp.id.toString() === period;
        }).name;
        return Number(periodNumberString.replace('-', ''));
    };

    const getPayPeriodAsString = (period: string) => {
        const periodString = payPeriods.find((pp) => {
            return pp.name.replace('-', '') === period;
        })?.name;
        return periodString;
    };

    const generateTimesheet = () => {
        if (!!invoices && invoices.length > selectedInvoiceIndex) {
            const documents = invoices[selectedInvoiceIndex]?.documents;
            let hasDocument = documents.some((d) =>
                                    d.documentType === 'TIMESHEET'
                                );
            if (hasDocument) {
                console.log(invoiceDetail);
                const payPeriod = getPayPeriodAsNumber(selectedPayPeriod);
                const correctInvoiceDetailInstance = invoices.filter(iv =>
                    iv.details.some(id => id && id.empNumber === 5082 && id.code === 'D' && (id.type === 'D' || id.type === 'C'))
                );
                console.log(correctInvoiceDetailInstance);
                const invoiceDetailInstance = invoices[selectedInvoiceIndex].details.find(id =>
                    id.empNumber !== 0 && id.code === 'D' && (id.type === 'D' || id.type === 'C')
                );
                getTimesheetReportFile(2, payPeriod, invoiceDetailInstance?.invNumber?.toString());
            } else {
                dispatch(actions.layout.showDialog(DialogList.GENERATE_TIMESHEET));
            }
        }
    };

/*     const generateTimeSummary = () => {
        dispatch(actions.layout.showDialog(DialogList.GENERATE_TIME_SUMMARY));
    }; */

    const toNullableNumber = (value: unknown): number | null => {
        const n = Number(value);
        return Number.isFinite(n) ? n : null;
    };
      
    const toNullableString = (value: unknown): string | null => {
        if (value == null) {
            return null;
        }
        const s = String(value).trim();
        return s.length > 0 ? s : null;
    };      

    const handleCreateManualInvoice = async (payload: Invoice): Promise<CreateInvoiceValidationResult> => {
        const result = await validateManualInvoice({
            clientNumber: toNullableNumber(payload.clientNumber),
            projectNumber: toNullableNumber(payload.projectNumber),
            subcode: toNullableString(payload.subCode),
            altSubcode: toNullableString(payload.altSubcode),
            office: toNullableString(payload.office),
            beginDate: payload.beginDate,
            endDate: payload.endDate,
            invoiceDate: payload.invoiceDate
        });

        console.log(result);
          
        if (!result) {
            return { isValid: false, fieldErrors: { clientNumber: 'Unknown Error.'} };
        } else if (result && !result.isValid) {
            return result;
        }
        // write a row to INVOICE_MASTER with payload
        payload.clientNumber = toNullableString(payload.clientNumber);
        payload.projectNumber = toNullableString(payload.projectNumber);
        payload.subCode = toNullableString(payload.subCode);
        payload.altSubcode = toNullableString(payload.altSubcode);
        payload.createdByNumber = tsdiNumber.toString();
        payload.createdByName = appContext.currentUser.username;
        payload.creationTime = new Date();
        const projectOffice = offices.find(o => o?.id === Number(payload?.office))?.office;
        payload.office = projectOffice;
        addMasterInvoice(payload);
        return { isValid: true };
    };

    const hideIdDialogAndRefreshInvoiceList = () => {
        getMasterInvoices();
        hideDialog();
    };

    const handleCreateSummaryDocument = (payload: InvoiceDocument) => {
        // write a row to INVOICE_DOCUMENT with payload
        const invoiceNumberString = !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : null;
        const invoiceNumber = !isNaN(Number(invoiceNumberString)) ? Number(invoiceNumberString) : 0;
        const addInvDocpayload: Partial<InvoiceDocument> = {
            clientNumber: selectedClient?.clientNumber?.toString(),
            projectNumber: selectedProject?.number?.toString(),
            invoiceNumber: invoiceNumber,
            subcode: !!payload?.subcode ? payload.subcode.toString() : null,
            altSubcode: !!payload?.altSubcode ? payload?.altSubcode?.toString() : null,
            documentType: 3,
            beginDate: payload?.beginDate,
            endDate: payload?.endDate,
            employeeNumber: !isNaN(Number(payload?.employeeNumber)) ? Number(payload.employeeNumber) : null
        };
        addInvoiceDocumentMetadata(addInvDocpayload);
    };

    const getUser = async () => {
        const result = await get(`v1.0/users/${appContext.currentUser.userId}`);

        if (response.ok) {
            setTsdiNumber(result.lmsNumber);
            setTsdiName(result.firstName + ' ' + result.lastName);
        }
    };

    const getNormalizedDocumentType = (documentType: string) => {
        switch (documentType) {
            case 'INVOICE' :
                return 'Invoice';
            case 'TIMESHEET' :
                return 'Timesheet';
            case 'OFFEXP' :
                return 'OffExp';
            case 'BOPTS' :
                return 'Bopts';
            case 'CSV' :
                return 'Csv';
            case 'RECEIPT' :
                return 'Receipt';
            default :
                return '';
        }
    };

    const handleGenerateDocument = (documentType: string, fileBlob: Blob) => {
        if (!fileBlob) {
            const invoiceNumber = Number(invoices[selectedInvoiceIndex].number);
            const existingDocs = invoices[selectedInvoiceIndex]?.documents;
            const invoiceSource = invoices[selectedInvoiceIndex]?.source;
            if (Array.isArray(existingDocs)) {
                const existingDoc = existingDocs.find((d) => d.documentType === documentType);
                if (existingDoc) {
                    hideDialogAndOpenArchiveReason(existingDoc.id);
                } else if (invoiceSource === 'M') {
                    handleAddDocument(documentType, fileBlob);
                } else {
                    let newQueryOptions = new ODataOptions();
                    let documentFilter = new ODataFilter(getNormalizedDocumentType(documentType), ODataFilterOperators.Equals, true);
                    newQueryOptions.addFilter(documentFilter);
                    let mergeFilter = new ODataFilter('merge', ODataFilterOperators.Equals, 4);
                    newQueryOptions.addFilter(mergeFilter);
                    const invoiceList = [invoiceNumber];
                    generateInvoiceDocuments(newQueryOptions, invoiceList);
                }
            }
        } else {
            handleAddDocument(documentType, fileBlob);
        }
    };

    const handleBulkDocumentGeneration = async (invoiceDocuments: Array<InvoiceDoc>, merge: number, invoiceNumber: number = 0) => {
        let newQueryOptions = new ODataOptions();
        if (Array.isArray(invoiceDocuments) && invoiceDocuments.length > 0) {
            let mergeFilter = new ODataFilter('merge', ODataFilterOperators.Equals, merge);
            newQueryOptions.addFilter(mergeFilter);

            for (let docIndex = 0; docIndex < invoiceDocuments.length; docIndex++) {
                const invoiceDoc = invoiceTypes.find(it => it.documentType === invoiceDocuments[docIndex].documentType);
                let documentFilter = new ODataFilter(invoiceDoc.documentType, ODataFilterOperators.Equals, true);
                newQueryOptions.addFilter(documentFilter);
            }
        }

        const formValues = getValues().invoices as Array<{ number: number, selection: boolean}>;

        const allSelected = !invoiceNumber ? formValues.every(inv => inv.selection) : [invoiceNumber];

        const selectedList = !invoiceNumber ? (allSelected ? [] : formValues
            .filter(inv => inv.selection === true)
            .map(inv => Number(inv.number))) : allSelected;
        if (Array.isArray(selectedList)) {
            newQueryOptions.merge(invoiceSearchOptions);
            generateInvoiceDocuments(newQueryOptions, selectedList);
            hideDialog();
        }
    };

/*    const handleGenerateBulkDocuments = async (invoiceDocuments: Array<InvoiceDoc>, merge: number) => {
        let newQueryOptions = new ODataOptions();
        if (Array.isArray(invoiceDocuments) && invoiceDocuments.length > 0) {
            for (let docIndex = 0; docIndex < invoiceDocuments.length; docIndex++) {
                let documentFilter = new ODataFilter(invoiceDocuments[docIndex].documentType, ODataFilterOperators.Equals, true);
                newQueryOptions.addFilter(documentFilter);
            }

            if (merge !== 4) {
                let documentFilter = new ODataFilter('merge', ODataFilterOperators.Equals, true);
                newQueryOptions.addFilter(documentFilter);
                documentFilter = new ODataFilter('beginQuery', ODataFilterOperators.Equals, true);
                newQueryOptions.addFilter(documentFilter);
            } else {
                let documentFilter = new ODataFilter('beginQuery', ODataFilterOperators.Equals, true);
                newQueryOptions.addFilter(documentFilter);
            }

            const formValues = getValues().invoices as Array<{ number: number, selection: boolean}>;

            const allSelected = formValues.every(inv => inv.selection);

            const selectedList = allSelected ? [] : formValues
                .filter(inv => inv.selection === true)
                .map(inv => Number(inv.number));
            if (Array.isArray(selectedList)) {
                newQueryOptions.merge(invoiceSearchOptions);
                generateInvoiceDocuments(newQueryOptions, selectedList);
                hideDialog();
            }
        }
    };

    const handleBulkCreateDocuments = async (invoiceDocuments: AnyObject) => {
        let merge = false;
        const docs = Array.isArray(invoiceDocuments)
            ? invoiceDocuments
            : Object.values(invoiceDocuments ?? {}); // handles objects like {0: {}, 1: {}}

        const invoiceList = (getValues().invoices as Array<Invoice>);
        
        const selectedInvoiceList = invoiceList
        .map((i, index) => (i.selection === true ? invoices[index] : null))
        .filter((x): x is NonNullable<typeof x> => x !== null);

        for (const iv of selectedInvoiceList) {
            const invoiceNumber = Number(iv?.number);
            for (const doc of docs) {
                let docType = Number(doc?.documentType);
                if (!isNaN(docType) && !isNaN(invoiceNumber)) {
                    let fileBlob: Blob | null = null;
                    switch (docType) {
                        case 0 :
                            const transmitInvoiceDoc = _.cloneDeep(sampleInvoice);
                            transmitInvoiceDoc.invoiceNumber = invoiceNumber.toString();
                            fileBlob = await pdf(<InvoicePdf invoice={transmitInvoiceDoc} />).toBlob();
                            break;
                        case 1 :
                            // Todo: get the correct period end date
                            const payPeriod = getTimePeriodNumber(new Date('2025-01-31'));
                            // Todo: query for all the employees that billed for this invoice and concatenate them
                            // Todo: remove the hard coded invoice number when we have more data
                            fileBlob = await getTimesheetReportFileBytes(2, payPeriod, 323919);
                            break;
                        case 2 :
                            break;
                        case 3 :
                            break;
                        case 4 :
                            break;
                        case 5 :
                            fileBlob = await getBaseCsvFile(iv.number, true);
                            break;
                        case 6 :
                            merge = true;
                            break;
                        default :
                            break;
                    }
                    if (fileBlob) {
                        handleCreateDocument(docType, iv.number, fileBlob);
                    }
                }
            }
            if (merge) {
                getInvoiceDocs(Number(iv.number), true);
            }
        }
        hideIdDialogAndRefreshInvoiceList();
    };

     const handleCreateDocumentMetadata = (payload: InvoiceDocument) => {
        // write a row to INVOICE_DOCUMENT with payload
        const invoiceNumberString = !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number : null;
        const invoiceNumber = !isNaN(Number(invoiceNumberString)) ? Number(invoiceNumberString) : 0;
        const addInvDocpayload: Partial<InvoiceDocument> = {
            clientNumber: payload?.clientNumber.toString(),
            projectNumber: payload?.projectNumber.toString(),
            invoiceNumber: invoiceNumber,
            subcode: payload?.subcode?.toString(),
            altSubcode: payload?.altSubcode?.toString(),
            documentType: !isNaN(Number(payload?.documentType)) ? Number(payload?.documentType) : 2,
            documentCategory : !isNaN(Number(payload?.documentCategory)) ? Number(payload?.documentCategory) : 0,
            recap: payload.recap,
            timesheet: payload?.timesheet,
            beginDate: payload?.beginDate,
            endDate: payload?.endDate,
            employeeNumber: !isNaN(Number(payload?.employeeNumber)) ? Number(payload.employeeNumber) : null,
            expense: payload?.expense,
            omitServices: payload?.omitServices
        };
        addInvoiceDocumentMetadata(addInvDocpayload);
    };  */

    const projectBilling = () => {
        window.open(`/client-project/projectbillingmaintenance`, '_blank', 'noopener,noreferrer');
    };

/*     const generateDocuments = () => {
        const tempInvoice = new Invoice();
        const invoiceDoc1 = new InvoiceDoc();
        invoiceDoc1.s3Key = 'Dudley-Land/Accounting/test/docs/Invoices/INVOICE/2025-12-10/Invoices_INVOICE_326450_2025-12-10.pdf';        
        const invoiceDoc2 = new InvoiceDoc();
        invoiceDoc2.s3Key = 'Dudley-Land/Accounting/test/docs/Invoices/TIMESHEET/2025-12-10/Invoices_TIMESHEET_326450_2025-12-10.pdf';
        const tempInvoiceDocs = new Array<InvoiceDoc>();
        tempInvoiceDocs.push(invoiceDoc1);
        tempInvoiceDocs.push(invoiceDoc2);
        tempInvoice.documents = _.cloneDeep(tempInvoiceDocs);
        generateInvoiceDocuments(tempInvoice);
    }; */

    const getSelectedInvoices = () => {
        const formValues = getValues()?.invoices as Array<{ number: number; selection: boolean }>;
        if (Array.isArray(formValues)) {
            const selectedSet = new Set(
                formValues.filter(f => f.selection).map(f => f.number));
            if (!selectedSet.size) {
                return false;
            }
        } else {
            return false;
        }

        return true;
    };

    const generateDocuments = () => {

        if (!getSelectedInvoices()) {
            dispatch(actions.layout.showDialog(DialogList.NO_SELECTED_INVOICES));
            return;
        }
        showDialog(DialogList.GENERATE_INVOICE_DOCUMENTS);
    };

    const handleZipDocuments = () => {
        if (!getSelectedInvoices()) {
            dispatch(actions.layout.showDialog(DialogList.NO_SELECTED_INVOICES));
            return;
        }
        handleZipArchive();
    };

    const manageDocuments = () => {
        dispatch(actions.layout.showDialog(DialogList.MANAGE_INVOICE_DOCUMENTS));
    };

    const initializeClientSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 100,
            idField: 'CL_NO',
            pageNumber: 1,
            columns: []
        };
        setClientSearchOptions(ODataOptions.from(tableConfig).addOrderBy('NAME1', ODataOrderByDirection.Ascending));
    };

    const initializeInvoiceSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 75,
            idField: 'INV_NO',
            pageNumber: 1,
            columns: []
        };
        setInvoiceSearchOptions(ODataOptions.from(tableConfig).addOrderBy('im.[INVOICE_NO]', ODataOrderByDirection.Descending));
    };

    const payPeriodToDate = (pp: string, isBeginDate: boolean): Date => {
        const normalized = pp.replace('-', '');
      
        if (!/^\d{6}$/.test(normalized)) {
            return null;
        }
      
        const year = Number(normalized.slice(0, 4));
        const period = Number(normalized.slice(4));
      
        if (period < 1 || period > 24) {
            return null;
        }
      
        // Month index (0-based)
        const month = Math.ceil(period / 2) - 1;
      
        const isFirstHalf = period % 2 === 1;
      
        if (isBeginDate) {
          return new Date(
            year,
            month,
            isFirstHalf ? 1 : 16
          );
        }
      
        // End date
        if (isFirstHalf) {
          return new Date(year, month, 15);
        }
      
        // Second half → last day of month
        return new Date(year, month + 1, 0);
    };

    const clearInvoiceSearchOptions = (caller: string) => {
        if (caller === 'clientSearchResults') {
            localStorage.removeItem('backOfficeSelectedClientNumber');
            localStorage.removeItem('backOfficeSelectedClientName');
            setSelectedClient(undefined);
            setSelectedClientNumber(undefined);
            localStorage.removeItem('backOfficeSelectedProjectName');
            localStorage.removeItem('backOfficeSelectedProjectNumber');
            setSelectedProject(undefined);
            setSelectedProjectNumber(undefined);
            localStorage.removeItem('backOfficeSelectedAltSubcodeNumber');
            localStorage.removeItem('backOfficeSelectedAltSubcodeName');
            setSelectedAltSubcode(undefined);
            setSelectedSubcode(undefined);
            localStorage.removeItem('backOfficeSelectedSubcodeNumber');
            localStorage.removeItem('backOfficeSelectedSubcodeName');
        } else if (caller === 'invoiceSearchResults') {
            setInvoiceSearchTerm(undefined);
            return;
        } else if (caller === 'all') {
            setSelectedPayPeriod(undefined);
            setSelectedClient(undefined);
            setSelectedGroupNumber(undefined);
            setSelectedProject(undefined);
            setSelectedProjectNumber(undefined);
            setSelectedTotal(undefined);
            setSelectedFormat(undefined);
            setSelectedOffice(undefined);
            setSelectedCreatedByNumber(undefined);
            localStorage.removeItem('backOfficeSelectedClientNumber');
            localStorage.removeItem('backOfficeSelectedClientName');
            localStorage.removeItem('backOfficeSelectedPayPeriod');
            localStorage.removeItem('backOfficeSelectedProjectName');
            localStorage.removeItem('backOfficeSelectedProjectNumber');
        }
        let newInvoiceSearchOptions = new ODataOptions();
        newInvoiceSearchOptions.clearFilters();
        newInvoiceSearchOptions.addPaging(1, 150);
        newInvoiceSearchOptions.addOrderBy('im.INVOICE_NO', ODataOrderByDirection.Descending);
        setInvoiceSearchOptions(newInvoiceSearchOptions);
    };

    const isValidDate = (d: Date): boolean => {
        return d instanceof Date && !isNaN(d.getTime());
    };      

    const resetInvoiceSearchOptions = () => {
        setFetchNextInvoicePage(true);
        console.log(fetchNextInvoicePage);
        let newInvoiceSearchOptions = _.cloneDeep(invoiceSearchOptions);
        newInvoiceSearchOptions.clearFilters();
        newInvoiceSearchOptions.addPaging(1, 150);
        const invoiceNumber = Number(invoiceSearchTerm);
        if (!isNaN(invoiceNumber) && invoiceNumber !== 0) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.INVOICE_NO', ODataFilterOperators.Equals, invoiceNumber));
        }
        if (!isNaN(selectedGroupNumber) && selectedGroupNumber > 0 && selectedGroupNumber !== null) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.[INV_IR_NO]', ODataFilterOperators.Equals, selectedGroupNumber));
        }
        if (!isNaN(selectedTotal) && selectedTotal !== undefined && selectedTotal !== null) {
            if (totalLike.current) {
                newInvoiceSearchOptions.addFilter(new ODataFilter('im.[TOTAL]', ODataFilterOperators.Contains, encodeURIComponent('%' + selectedTotal + '%')));
            } else {
                newInvoiceSearchOptions.addFilter(new ODataFilter('im.[TOTAL]', ODataFilterOperators.Equals, selectedTotal));
            }
        }
        if (!isNaN(selectedCreatedByNumber) && selectedCreatedByNumber > 0 && selectedCreatedByNumber !== null) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.[CREATE_BY_NO]', ODataFilterOperators.Equals, selectedCreatedByNumber));
        }
        if (selectedSource && selectedSource.length > 0) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.[SOURCE]', ODataFilterOperators.Equals, selectedSource));
        }
        if (!!selectedPayPeriod && !isValidDate(selectedBeginDate) && !isValidDate(selectedEndDate)) {
            const beginDate = payPeriodToDate(selectedPayPeriod, true).toISOString().split('T')[0];
            const endDate = payPeriodToDate(selectedPayPeriod, false).toISOString().split('T')[0];
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.BEG_DATE', ODataFilterOperators.LessThanOrEqual, endDate));
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.END_DATE', ODataFilterOperators.GreaterThanOrEqual, beginDate));
        }
        if (isValidDate(selectedInvoiceDate)) {
            const invoiceDate = new Date(selectedInvoiceDate).toISOString().split('T')[0];
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.[INV_DATE]', ODataFilterOperators.Equals, invoiceDate));
        }
        if (isValidDate(selectedBeginDate)) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.BEG_DATE', ODataFilterOperators.GreaterThanOrEqual, selectedBeginDate.toISOString().split('T')[0]));
        }
        if (isValidDate(selectedEndDate)) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.END_DATE', ODataFilterOperators.LessThanOrEqual, selectedEndDate.toISOString().split('T')[0]));
        }
        if (!!selectedClient) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.CL_NO', ODataFilterOperators.Equals, selectedClient.clientNumber));
        }
        if (selectedProject || selectedProjectNumber) {
            const searchForProject = selectedProject?.number ? selectedProject?.number : selectedProjectNumber;
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.PR_NO', ODataFilterOperators.Equals, searchForProject));
        }
        if (!!selectedSubcode) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.SC_NO', ODataFilterOperators.Equals, selectedSubcode.number));
        }
        if (!!selectedAltSubcode) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.UN_NO', ODataFilterOperators.Equals, selectedAltSubcode.number));
        }
        if (!!selectedFormat) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.[FMT_TYPE]', ODataFilterOperators.Equals, selectedFormat));
        }
        if (!!selectedOffice && selectedOffice !== 'ALL') {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.PR_OFFICE', ODataFilterOperators.Equals, selectedOffice));
        }
        if (excludePostedInvoices.current) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.POST_TO_AR', ODataFilterOperators.NotEquals, 'Y'));
        }
        if (excludeNonVoidInvoices.current) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.VOID', ODataFilterOperators.NotEquals, 'Y'));
        }
        if (excludeVoidInvoices.current) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.VOID', ODataFilterOperators.NotEquals, 'N'));
        }
        if (excludeUnPostedInvoices.current) {
            newInvoiceSearchOptions.addFilter(new ODataFilter('im.POST_TO_AR', ODataFilterOperators.NotEquals, 'N'));
        }
        const searchSortDirection = sortDirection.current ? ODataOrderByDirection.Descending : ODataOrderByDirection.Ascending;
        newInvoiceSearchOptions.addOrderBy('im.INVOICE_NO', searchSortDirection);
        setInvoiceSearchOptions(newInvoiceSearchOptions);
    };

    const prepFormData = () => {
        if (!!clients && clients?.length > 0) {
            console.log(clients[0]);
        }
    };

    const displayTitle = () => {
        const title = 'Invoice Maintenance';

        return title;
    };

    const displayHeading2 = () => {
        const title = 'Invoices';

        return title;
    };

    const handleUpdateDocument = () => {
        dispatch(actions.layout.showDialog(DialogList.VOID_INVOICE));
    };

    const handleVoidInvoice = () => {
        dispatch(actions.layout.showDialog(DialogList.VOID_INVOICE));
    };

    const handleInvoiceDetails = () => {
        showInvoiceDetailsDialog();
    };

    const handleViewEditHeading = () => {
        showInvoiceDescriptionDialog();
    };

/*     const handleViewDescription = () => {
        showInvoiceDescriptionDialog();
    }; */

    const handleViewDocumentMaintenance = (invoiceNumber: number, invoiceGroupNumber: number) => {
        if (invoiceNumber && !invoiceGroupNumber) {
            getInvoiceDocs(invoiceNumber);
            getArchivedInvoiceDocs(invoiceNumber);
            manageDocuments();
        } else if (invoiceGroupNumber && !invoiceNumber) {
            setIgNumber(invoiceGroupNumber.toString());
            getInvoiceGroupDocs(invoiceGroupNumber);
            getArchivedInvoiceGroupDocs(invoiceGroupNumber);
            manageDocuments();
        }
    };

    const handleGenerateInvoiceListing = async (formData: AnyObject) => {
        const outputType = 2; // PDF format
        const startDate = formData.beginDate;
        const endDate = formData.endDate;

        const params = new URLSearchParams({
            clientNumber: !formData || formData.clientNumber === '' ? 0 : formData.clientNumber,
            projectNumber: !formData || formData.projectNumber === '' ? 0 : formData.projectNumber,
            subcode: !formData || formData.subcode === '' ? 0 : formData.subcode,
            accountNumber: !formData || formData.accountNumber === '' ? 0 : formData.accountNumber,
            beginDate: formData.beginDate,
            endDate: formData.endDate,
            office: formData.office
        });

        await get(`v1.0/reports/GetReport/${outputType}/invoiceListing?${params}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `${new Date(startDate).toISOString().split('T')[0]}-${new Date(endDate).toISOString().split('T')[0]}_InvoiceListing.pdf`;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
    };

    const handleGenerateExcelSummary = async (formData: AnyObject) => {
        const outputType = 1; // Excel format
        const startDate = formData.begDate;
        const endDate = formData.endDate;
        const invoiceNumber = invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].number : 0;

        const params = new URLSearchParams({
            clientNumber: formData.clientNumber,
            projectNumber: !formData || formData.projectNumber === '' ? 0 : formData.projectNumber,
            subcode: !formData || formData.subCode === '' ? 0 : formData.subCode,
            clientLandmanNumber: !formData || formData.clientLandmanNumber === '' ? 0 : formData.clientLandmanNumber,
            beginDate: formData.begDate,
            endDate: formData.endDate,
            summaryType: formData.summaryType
        });

        await get(`v1.0/reports/GetReport/${outputType}/excelSummary?${params}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `${new Date(startDate).toISOString().split('T')[0]}-${new Date(endDate).toISOString().split('T')[0]}-${invoiceNumber}_ExcelSummary.xlsx`;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
    };

    const handleGenerateExcelInvoiceList = async (formData: AnyObject) => {
        const outputType = 1; // Excel format
        const startDate = formData.begDate;
        const endDate = formData.endDate;

        const params = new URLSearchParams({
            clientNumber: formData.clientNumber,
            projectNumber: !formData || formData.projectNumber === '' ? 0 : formData.projectNumber,
            beginDate: formData.begDate,
            endDate: formData.endDate,
            office: formData.office
        });

        await get(`v1.0/reports/GetReport/${outputType}/excelInvoiceList?${params}`);
        if (response.ok) {
            await response.blob().then((blob) => {
                const blobUrl = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = blobUrl;
                a.download = `${new Date(startDate).toISOString().split('T')[0]}-${new Date(endDate).toISOString().split('T')[0]}_InvoiceList.xlsx`;
                a.click();
                window.URL.revokeObjectURL(blobUrl);
            });
        }
    };

    const handleCreateDocument = async (documentType: number, invoiceNumber: string, fileBlob: Blob = null) => {
        // const transmitInvoiceDoc = _.cloneDeep(sampleInvoice);
        // transmitInvoiceDoc.invoiceNumber = invoiceNumber;
        if (documentType === 0) {
            // Create an invoice for the supplied invoice index
            // const invoiceBlob = await pdf(<InvoicePdf invoice={transmitInvoiceDoc} />).toBlob();
            if (fileBlob) {                
                uploadInvoiceDocPdf(fileBlob, 'INVOICE', invoiceNumber);
            } else {
                getInvoiceReportFile(2, invoiceNumber);
            }
        } else if (documentType === 1) {
            // Create a timesheet file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'TIMESHEET', invoiceNumber);
        } else if (documentType === 2) {
            // Create a .csv file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'OFFEXP', invoiceNumber);
        } else if (documentType === 3) {
            // Create a merged file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'RECEIPT', invoiceNumber);
        } else if (documentType === 4) {
            // Create an Office Expenses Receipt file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'BOPTS', invoiceNumber);
        } else if (documentType === 5) {
            // Create an Office Expenses Receipt file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'CSV', invoiceNumber, 'C', 'csv');
        } else if (documentType === 6) {
            // Create an Office Expenses Receipt file for this invoice
            uploadInvoiceDocPdf(fileBlob, 'MERGE', invoiceNumber);
        }
    };

    const handleDeleteDocument = (documentId: number, isArchived: boolean) => {
        if (documentId > 0) {
            if (appContext.currentUser.isAdmin && isArchived) {
                onDeleteDocument(documentId);
            } else {
                setUpdatingDocument({ docId: documentId, archiveAction: 0 });
            }
        }
    };

    const onDeleteDocument = async (documentId: number) => {
        if (!!documentId) {
            let result = await del(`/v1.0/s3bucket/invoice/documentid/${documentId}`);

            if (response.ok && result) {
                if (invoices && Array.isArray(invoices) && invoices.length > selectedInvoiceIndex) {
                    const invoiceNumber = invoices[selectedInvoiceIndex].number;
                    const numericInvoiceNumber = Number(invoiceNumber);
                    getMasterInvoices();
                    getArchivedInvoiceDocs(numericInvoiceNumber);
                    getInvoiceDocs(numericInvoiceNumber);
                }
            } else {
                console.log('Unable to delete invoice document!');
            }
        }
    };

    const handleAddDocuments = () => {
        dispatch(actions.layout.showDialog(DialogList.ADD_INVOICE_DOCUMENT));
    };

    const hideDialogAndOpenArchiveReason = (documentId: number) => {
        hideDialog();
        setOpenArchiveReasonDialog(new Object());
        setUpdatingDocument({ docId: documentId, archiveAction: 1});
    };

    const hideDialogAndOpenDocumentManagement = () => {
        hideDialog();
        setOpenDocumentManagement(new Object());
    };

    const hideDialogAndOpenInvoiceGroups = () => {
        hideDialog();
        if (showInvoiceGroups) {
            setShowInvoiceGroups(false);
            setOpenInvoiceGroups(new Object());
        }
    };

    const hideDialogAndOpenGenerateTimesheet = () => {
        hideDialog();
        setOpenGenerateTimesheet(new Object());
    };

    const handleAddDocument = async (type: string, fileBlob: Blob = null) => {
        let hideAndOpenDM = true;
        const invoiceNumber = Array.isArray(invoices) && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].number : null;
        const isManual = Array.isArray(invoices) && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].source === 'M' : false;
        if (fileBlob instanceof Blob && fileBlob.size > 0 && typeof type === 'string' && type.length > 0 && invoiceNumber) {
            // Upload the file blob to the invoice documents for the selected invoice
            setGeneratingDocument(true);
            uploadInvoiceDocPdf(fileBlob, type, invoiceNumber);
        } else if (typeof type === 'string' && type.length > 0) {
            switch (type) {
                case 'INVOICE' :
                    // const invoicePdfBytes = await renderInvoicePdf(sampleInvoice);
                    // fileBlob = new Blob([invoicePdfBytes], { type: 'application/pdf' });
                    // uploadInvoiceDocPdf(fileBlob, type, invoiceNumber);
                    handleCreateDocument(0, invoiceNumber, fileBlob);
                    break;
                case 'BOPTS' :
                case 'TIMESHEET':
                    hideDialogAndOpenGenerateTimesheet();
                    hideAndOpenDM = false;
                    break;
                case 'RECEIPT':
                    getExpenseReceiptsForInvoice(Number(invoiceNumber), isManual);
                    break;
                default:
                    break;
            }
        }

        if (hideAndOpenDM) {
            hideDialogAndOpenDocumentManagement();
        }
    };

    const addInvoiceDocumentMetadata = async (payload: InvoiceDocument) => {
        if (!!payload) {
            let result = await post(`/v1.0/AccountsPayable/invoice/document/metadata`, payload);
    
            if (response.ok && result) {
                getMasterInvoices();
            } else {
                console.log('Unable to add invoice document metadata!!!');
            }
        }
    };

    const updateInvoiceDocument = async (payload: InvoiceDoc) => {
        if (!!payload) {
            let result = await post(`/v1.0/AccountsPayable/invoice/document/update`, payload);
    
            if (response.ok && result) {
                getMasterInvoices();
                getInvoiceDocs(payload?.invoiceNumber, false);
                getArchivedInvoiceDocs(payload?.invoiceNumber, false);
            } else {
                console.log('Unable to add update invoice doc!');
            }
            setOpenDocumentManagement(new Object());
        }
    };

    const handleGetReceipts = () => {
        getOfficeExpenseReceiptsThumbnails();
    };

    const addMasterInvoice = async (payload: Invoice) => {
        if (!!payload) {
            let result = await post(`/v1.0/AccountsPayable/master/invoice`, payload);

            if (response.ok && result === 1) {
                getMasterInvoices();
            } else {
                console.log('Unable to get add expense data!!!');
            }
        }
    };

    const postInvoicesToAr = async () => {
        const formValues = getValues().invoices as Array<{ number: number, selection: boolean}>;

        const payload = formValues
            .filter(inv => inv.selection === true)
            .map(inv => Number(inv.number));
        let result = await post(`/v1.0/AccountsPayable/invoices/ar/post`, payload);

        if (response.ok && result > 0) {
            runQuery();
            alert(`${result} invoice(s) posted to A/R.`);
        } else {
            console.log('Unable to get add expense data!!!');
            alert('No invoices were posted to A/R.');
        }
    };

    const displayInoiceMasterButtons = () => {
        return (
            <>
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to First Invoice"
                    reactIcon={BiArrowToLeft}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Move to 1st project')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Previous Invoice"
                    reactIcon={BiLeftArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Move to previous project')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Create Invoice"
                    reactIcon={BiAddToQueue}
                    iconHoverColor="blue"
                    iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                    onClick={() => createManualInvoice()}
                />
                {/*<Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Save Staffing Changes"
                    reactIcon={FaRegSave}
                    type={'button'}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => onSaveChanges()}
                />*/}
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Next Invoice"
                    reactIcon={BiRightArrowAlt}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Move to next project')}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Move to Last Invoice"
                    reactIcon={BiArrowToRight}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => alert('Move to last project')}
                />
                {/*<Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Void Status"
                    reactIcon={FaBan}
                    iconHoverColor="blue"
                    iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Invoice Description"
                    reactIcon={FaArrowUp}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => handleViewEditHeading()}
                />
                <Button
                    style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                    text={''}
                    title="Refresh"
                    reactIcon={BiCloudLightning}
                    iconHoverColor="blue"
                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                    onClick={() => resetInvoiceSearchOptions()}
                />*/}
            </>
        );
    };
    
    const setAllInvoicesSelectedOrDeselected = (state: boolean) => {
        if (!invoices || invoices.length < 1) {
            return;
        }
        for (let invoiceIndex = 0; invoiceIndex < invoices.length; invoiceIndex++) {
            setValue(`invoices[${invoiceIndex}].selection`, state, { shouldDirty: true });
        }
    };

    const hasCsv = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'CSV');
    };

    const hasInvoice = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'INVOICE');
    };

    const hasTimeSheet = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'TIMESHEET');
    };

    const hasRec = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'RECEIPT');
    };

    const hasMerged = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'MERGE');
    };

    const hasBop = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'BOPTS');
    };

    const hasOfficeExpensesDoc = (invoiceIndex: number) => {
        return invoices[invoiceIndex].documents.some(doc => doc.documentType === 'OFFEXP');
    };

    const downloadOrGenerateInvoiceDocument = (invoiceIndex: number, documentType: string) => {
        if (Array.isArray(invoices) && invoices.length >= invoiceIndex) {
            if (Array.isArray(invoices[invoiceIndex]?.documents) && invoices[invoiceIndex].documents.length > 0) {
                const existingDoc = invoices[invoiceIndex].documents.find(i => i.documentType === documentType);
                if (existingDoc) {
                    const invoiceNumber = invoices[invoiceIndex].number;
                    if (existingDoc?.s3Key) {                        
                        if (!isNaN(Number(invoiceNumber))) {
                            downloadInvoiceFile(existingDoc);
                        }
                    } else if (existingDoc.hasBlob) {
                        downloadInvoiceFileBlob(invoiceNumber, documentType);
                    }
                } else {
                    if (documentType === 'INVOICE') {
                        handleAddDocuments();
                    } else if (documentType === 'TIMESHEET') {
                        handleGenerateTimesheet(invoiceIndex, false);
                    }
                }
            } else {
                if (documentType === 'INVOICE') {
                    handleAddDocuments();
                } else if (documentType === 'TIMESHEET') {
                    handleGenerateTimesheet(invoiceIndex, false);
                }
            }
        }
    };

    const displayInvoiceList = () => {
        return <div>
            <table className={'project-billing'}>
                <thead className={'project-billing'}>
                    <tr style={{textAlign: 'left'}} className={'project-billing'}>
                        <th style={{width: '2%'}}/>
                        <th style={{width: '3%'}}>Inv #</th>
                        <th style={{width: '3.5%'}}>Beg Date</th>
                        <th style={{width: '3.5%'}}>End Date</th>
                        <th style={{width: '2.5%'}}>Office</th>
                        <th style={{width: '3%'}}>Client</th>
                        <th style={{width: '2.5%'}}>Project</th>
                        <th style={{width: '3%'}}>Subcode</th>
                        <th style={{width: '2%'}}>AltSC</th>
                        {/* <th style={{width: '2%'}}>Factor</th> */}
                        <th style={{whiteSpace: 'nowrap', width: '1.5%'}}>Acct #</th>
                        <th style={{width: '2%'}}>Fmt</th>
                        <th style={{width: '3.5%'}}>Total</th>
                        <th style={{width: '1%'}}>Vo</th>
                        <th style={{width: '1.5%'}}>Src</th>
                        <th style={{width: '1.5%'}}>A/R</th>
                        <th style={{width: '1.5%'}}>Vo A/R</th>
                        <th style={{width: '1.5%'}}>CSV</th>
                        <th style={{width: '1.5%'}}>Inv</th>
                        <th style={{width: '1%'}}>TS</th>
                        <th style={{width: '1%'}}>Rec</th>
                        <th style={{width: '1.5%'}}>Off</th>
                        <th style={{width: '1.5%'}}>BOP</th>
                        {/* <th style={{width: '1.5%'}}>Cert</th>
                        <th style={{width: '1.5%'}}>IS</th>
                        <th style={{width: '1.5%'}}>Excl</th> */}
                        <th style={{width: '2%'}}>Mrgd</th>
                        <th style={{whiteSpace: 'nowrap', width: '4.5%'}}>Created by</th>
                        <th style={{width: '4%'}}>Date</th>
                        <th style={{width: '3%'}}>IGN</th>
                        <th style={{width: '3%'}}/>
                    </tr>
                </thead>                
                <tbody style={{maxHeight: '45vh'}}>
                {!!invoices && invoices.length > 0 && invoices?.map(
                    (inv: Invoice, index: number) => {
                    return (
                        <tr
                            key={index}
                            onClick={() => setSelectedInvoiceIndex(index)}
                            className="table-item-hover"
                            style={{backgroundColor: index === selectedInvoiceIndex ? '#707070' : '',  textAlign: 'center' }}
                        >
                            <td style={{ width: '1%' }}>
                                <RHFCheckbox
                                    style={{verticalAlign: 'middle'}}
                                    name={`invoices[${index}].selection`}
                                    register={register}
                                    bodyStyle={{ width: '16%', marginTop: '.5rem' }}
                                    errors={errors}
                                    onChange={(e: ChangeEvent<HTMLInputElement>) => setValue(`invoices[${index}].selection`, e.currentTarget.checked)}
                                />
                            </td>
                            <td style={{ width: '3.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].number`}
                                    type="text"
                                    defaultVal={inv?.number?.toString()}
                                    errors={errors}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : '#d5f7f5'}}
                                    bodyStyle={{ width: '100%' }}
                                    readOnly={true}
                                    register={register}
                                />
                            </td>
                            <td style={{ width: '4.2%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].beginDate`}
                                    type="text"
                                    defaultVal={
                                        inv?.beginDate
                                            ? new Date(inv.beginDate).toLocaleDateString('en-US', {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })
                                            : ''
                                        }
                                    register={register}
                                    errors={errors}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '4.2%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].endDate`}
                                    type="text"
                                    defaultVal={
                                        inv?.endDate
                                            ? new Date(inv.endDate).toLocaleDateString('en-US', {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })
                                            : ''
                                        }
                                    register={register}
                                    errors={errors}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '2%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].office`}
                                    type="text"
                                    defaultVal={!!inv?.office ? inv.office.toString() : ''}
                                    register={register}
                                    errors={errors}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{  width: '3.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].clientNumber`}
                                    defaultVal={!!inv?.clientNumber ? inv.clientNumber.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '3%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].projectNumber`}
                                    defaultVal={!!inv?.projectNumber ? inv.projectNumber.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '3%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].subCode`}
                                    defaultVal={!!inv?.subCode ? inv.subCode.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '2.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].altSubcode`}
                                    defaultVal={!!inv?.altSubcode ? inv.altSubcode.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '2%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].accountNumber`}
                                    defaultVal={!!inv?.accountNumber ? inv.accountNumber.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%' }}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            {/* <td style={{ width: '3%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].factor`}
                                    defaultVal={!!inv?.factor ? inv.factor.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                />
                            </td> */}
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].formatType`}
                                    defaultVal={!!inv?.formatType ? inv.formatType.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '4%' }}>
                                <RHFInputBox
                                    bodyClassName={'project-billing form-field-right'}
                                    className={'project-billing form-field-right'}
                                    name={`invoices[${index}].total`}
                                    defaultVal={!!inv?.total ? inv.total.toLocaleString('en-US', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                      }) : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    className={'project-billing form-field-center'}
                                    name={`invoices[${index}].voided`}
                                    defaultVal={!!inv?.voided ? 'Y' : 'N'}
                                    style={{width: '100%', backgroundColor: `${ !inv?.voided && index === selectedInvoiceIndex ? '#FFFF66' : (inv?.voided ? 'rgb(222, 42, 42)' : '')}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    className={'project-billing form-field-center'}
                                    name={`invoices[${index}].source`}
                                    defaultVal={!!inv?.source ? inv.source.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].postToAR`}
                                    defaultVal={inv?.postToArOpenIg ? 'W' : (inv?.postToAR ? 'Y' : 'N')}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].postVoid`}
                                    defaultVal={!!inv?.postVoid ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].csv`}
                                    defaultVal={!!hasCsv(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasCsv(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'CSV')}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].inv`}
                                    defaultVal={!!hasInvoice(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasInvoice(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'INVOICE')}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].timesheetDoc`}
                                    defaultVal={!!hasTimeSheet(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasTimeSheet(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'TIMESHEET')}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].rec`}
                                    defaultVal={!!hasRec(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasRec(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'RECEIPT')}
                                />
                            </td>
                            {/* <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].cert`}
                                    defaultVal={!!inv?.postVoid ? inv.postVoid.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].IS`}
                                    defaultVal={!!inv?.postVoid ? inv.postVoid.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].Xcel`}
                                    defaultVal={!!inv?.postVoid ? inv.postVoid.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                />
                            </td> */}
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].off`}
                                    defaultVal={!!hasOfficeExpensesDoc(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasOfficeExpensesDoc(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'OFFEXP')}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].bop`}
                                    defaultVal={!!hasBop(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasBop(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'BOPTS')}
                                />
                            </td>
                            <td style={{ width: '1.5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].Mrgd`}
                                    defaultVal={!!hasMerged(index) ? 'Y' : 'N'}
                                    className={'project-billing form-field-center'}
                                    style={{width: '100%', backgroundColor: `${!!hasMerged(index) ? '#66FF00' : 'rgb(222, 42, 42)'}`}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    // onDoubleClick={() => downloadInvoiceFile(inv.documents.find(d => d.documentType === 'MERGE')?.s3Key, inv.number.toString() + '_' + 'merged.pdf')}
                                    onDoubleClick={() => downloadOrGenerateInvoiceDocument(index, 'MERGE')}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '5%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].createdByNumber`}
                                    defaultVal={!!inv?.createdByNumber ? inv.createdByNumber.toString() : ''}
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '4%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].invoiceDate`}
                                    defaultVal={
                                        inv?.invoiceDate
                                            ? new Date(inv.invoiceDate).toLocaleDateString('en-US', {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })
                                            : ''
                                        }
                                    style={{width: '100%', backgroundColor: index === selectedInvoiceIndex ? '#FFFF66' : ''}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                />
                            </td>
                            <td style={{ width: '3%' }}>
                                <RHFInputBox
                                    name={`invoices[${index}].invoiceGroupNumber`}
                                    defaultVal={!!inv?.invoiceIrNumber ? inv.invoiceIrNumber.toString() : ''}
                                    style={{width: '100%', backgroundColor: inv?.groupClosed ? 'rgb(222, 42, 42)' : (index === selectedInvoiceIndex ? '#FFFF66' : '')}}
                                    bodyStyle={{ width: '100%'}}
                                    register={register}
                                    errors={errors}
                                    readOnly={true}
                                    onDoubleClick={() => showInvoiceGroupingDialog()}
                                />
                            </td>
                            <td style={{ width: '1%' }}>
                                <Button
                                    reactIcon={FaInfoCircle}
                                    iconStyle={{fill: 'blue', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                    iconHoverColor="blue"
                                    title="View/Edit Details"
                                    style={{ height: '3rem', background: 'transparent' }}
                                    onClick={() => handleInvoiceDetails()}
                                />
                            </td>
                            <td style={{ width: '1%' }}>
                                <Button
                                    title="View/Edit Description"
                                    reactIcon={FaArrowUp}
                                    iconHoverColor="blue"
                                    style={{ height: '3rem', background: 'transparent' }}
                                    iconStyle={{fill: 'rgb(99, 147, 193)', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                    onClick={() => handleViewEditHeading()}
                                />
                            </td>
{/*                             <td style={{ width: '1%' }}>
                                <Button
                                    reactIcon={FaEye}
                                    iconStyle={{fill: 'violet', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                    iconHoverColor="blue"
                                    title="View Description"
                                    style={{ height: '3rem', background: 'transparent' }}
                                    onClick={() => handleViewDescription()}
                                />
                            </td> */}
                            <td style={{ width: '1%' }}>
                                <Button
                                    reactIcon={FaBan}
                                    iconStyle={{fill: 'red', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                    iconHoverColor="blue"
                                    title="Void Invoice"
                                    style={{ height: '3rem', background: 'transparent' }}
                                    onClick={() => handleVoidInvoice()}
                                />
                            </td>
                            <td style={{ width: '1%' }}>
                                <Button
                                    reactIcon={FaFileSignature}
                                    iconStyle={{fill: 'black', width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                    iconHoverColor="blue"
                                    title="Manage Documents"
                                    style={{ marginRight: '1rem', height: '3rem', background: 'transparent' }}
                                    onClick={() => handleViewDocumentMaintenance(Number(invoices[index].number), null)}
                                />
                            </td>
                        </tr>                        
                    );
                })}
                </tbody>
            </table>
        </div>;
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };

    const hideDialog = (refreshInvoiceList: boolean = false) => {
        if (refreshInvoiceList) {
            getMasterInvoices();
        }
        dispatch(actions.layout.hideDialog());
    };

    const onSubmit = () => {
        console.log('onSubmit called for save project');
    };

    const showInvoiceDescriptionDialog = () => {
        showDialog(DialogList.INVOICE_DESCRIPTION);
    };
/*
    const updateInvoices = () => {
        alert('Implement update invoices');
    };

    const onSaveChanges = () => {
        updateInvoices();
    };

    const findClient = () => {
        showDialog(DialogList.FIND_CLIENT);
    };

    const reportOptions = () => {
        alert('Implement report options');
    };

    const moveToPreviousProject = () => {
        alert('Implement move to previous project');
    };

    const generateReports = () => {
        alert('Implement reports.');
    };

    const prospectByManagerReport = () => {
        alert('Implement Prospect By Manager Report.');
    };
*/
    const runQuery = () => {
        setExecuteInvoiceQuery(new Object());
    };

    const resetPayPeriodSearchOptions = () => {
        setFetchNextPayPeriodsPage(true);
        console.log(fetchNextPayPeriodsPage);
        let newPayPeriodSearchOptions = _.cloneDeep(payPeriodSearchOptions);
        newPayPeriodSearchOptions.clearFilters();
        newPayPeriodSearchOptions.addPaging(1, 200);
        const payPeriod = Number(payPeriodSearchTerm.replace('-', ''));
        if (!isNaN(payPeriod)) {
            newPayPeriodSearchOptions.addFilter(new ODataFilter('PERIOD_NO', ODataFilterOperators.Contains, payPeriod));
        }
        setPayPeriodSearchOptions(newPayPeriodSearchOptions);
    };

    const getPayPeriodDates = (payPeriod: string): { beginDate: Date; endDate: Date } | null => {
        if (!!payPeriod && /^\d{6}$/.test(payPeriod)) {
            const year = parseInt(payPeriod.substring(0, 4), 10);
            const periodNumber = parseInt(payPeriod.substring(4), 10);
    
            // Pay period 1 corresponds to Jan 1–15, 2 is Jan 16–end, 3 is Feb 1–15, etc.
            const month = Math.floor((periodNumber - 1) / 2); // 0-based month
            const isFirstHalf = (periodNumber % 2) === 1;
    
            let beginDate: Date;
            let endDate: Date;
    
            if (isFirstHalf) {
                beginDate = new Date(year, month, 1);
                endDate = new Date(year, month, 15);
            } else {
                beginDate = new Date(year, month, 16);
                endDate = new Date(year, month + 2, 0); // Last day of the month
            }
    
            return { beginDate, endDate };
        } else {
            return null;
        }
    };    

    const initializePayPeriodSearchSettings = () => {
        const tableConfig: ITableConfig = {
            rowCount: 500,
            idField: 'Id',
            pageNumber: 1,
            columns: []
        };
        const newPayPeriodSearchOptions = ODataOptions.from(tableConfig);
        newPayPeriodSearchOptions.addOrderBy('Id', ODataOrderByDirection.Descending);
        const storedPayperiod = localStorage.getItem('backOfficeSelectedPayPeriod');
        if (!!storedPayperiod && !isNaN(Number(storedPayperiod))) {
            const dates = getPayPeriodDates(storedPayperiod);
            const beginDate = new Date(dates.beginDate).toLocaleDateString();
            const endDate = new Date(dates.endDate).toLocaleDateString();
            newPayPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThanOrEqual, endDate));
            newPayPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThanOrEqual, beginDate));
            setSelectedPayPeriod(storedPayperiod);
        } else {
            const currentDate = new Date();
            const currentDate2 = new Date();
            const beginDate = new Date(currentDate.setMonth(currentDate.getMonth() - 12)).toLocaleDateString().replace('/', '-').replace('/', '-');
            const endDate = new Date(currentDate2.setMonth(currentDate2.getMonth() + 6)).toLocaleDateString().replace('/', '-').replace('/', '-');
            newPayPeriodSearchOptions?.addFilter(new ODataFilter('end_date', ODataFilterOperators.LessThanOrEqual, endDate));
            newPayPeriodSearchOptions?.addFilter(new ODataFilter('beg_date', ODataFilterOperators.GreaterThanOrEqual, beginDate));
        }
        
        setPayPeriodSearchOptions(newPayPeriodSearchOptions);
    };

    function insertCharAt(str: string, charToInsert: string, index: number) {
        return str.slice(0, index) + charToInsert + str.slice(index);
    }

    const getPayPeriods = async () => {        
        const queryString = payPeriodSearchOptions.toString();
        let result = await get(`/v1.0/AccountsPayable/payperiods${queryString}`);

        if (response.ok) {
            setPayPeriods(result.items.map((pp: PayPeriod) => {
                const insertIndex = pp.periodNumber.toString().length - 2;
                const ppString = insertCharAt(pp.periodNumber.toString(), '-', insertIndex);
                return { id: pp.id, name: ppString, beginDate: pp.beginDate, endDate: pp.endDate };
            }));
        } else {
            console.log('Unable to get pay period data!!!');
        }
    };

    const mergeExistingInvoiceDocuments = async (
        docsToMerge: InvoiceDoc[],
        invoiceNumber: string | null
    )  => {
        if (!docsToMerge || docsToMerge.length === 0 || isNaN(Number(invoiceNumber)) || !invoiceNumber) {
            return;
        }

        await handleBulkDocumentGeneration(docsToMerge, 2, Number(invoiceNumber));
    };

    const mergeInvoiceDocuments = async (
        docsToMerge: InvoiceDoc[],
        invoiceNumber: string | null   // pass this in instead of reading external state
    ): Promise<Uint8Array | null> => {
        if (!docsToMerge || docsToMerge.length === 0) {
            return null;
        }

        docsToMerge.sort((a, b) =>
            Number(b.documentType === 'INVOICE') - Number(a.documentType === 'INVOICE')
        );          

        const pdfs: Uint8Array[] = [];
        for (const doc of docsToMerge) {
            if (!doc.s3Key) {
                continue;
            }

            const arrayBuffer = await downloadInvoicePdfBytes(doc.s3Key);
            if (!arrayBuffer) {
                continue;
            }

            pdfs.push(new Uint8Array(arrayBuffer));
        }

        if (pdfs.length === 0) {
            return null;
        }

        // Pure + concurrency safe
        const mergedPdf = await concatPdfList(pdfs);

        // Create an isolated download link
        (() => {
            const blob = new Blob([mergedPdf], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Invoice_${invoiceNumber ?? 'unknown'}_merged.pdf`;
            link.click();
        })();

        // Upload – decoupled from concurrency
        const uploadBlob = new Blob([mergedPdf], { type: 'application/pdf' });
        uploadInvoiceDocPdf(uploadBlob, 'MERGE', invoiceNumber);

        return mergedPdf;
    };

    const concatPdfList = async (pdfs: Uint8Array[]): Promise<Uint8Array> => {
        if (!pdfs || pdfs.length === 0) {
            throw new Error('No PDF files provided.');
        }

        // Create the destination (merged) PDF
        const merged = await PDFDocument.create();

        for (const pdfBytes of pdfs) {
            const doc = await PDFDocument.load(pdfBytes);
            const copiedPages = await merged.copyPages(doc, doc.getPageIndices());
            copiedPages.forEach((page) => merged.addPage(page));
        }

        // Save merged PDF as a new Uint8Array
        return await merged.save();
    };

    const handleCloseReceiptViewerDialog = () => {
        if (relaunchDialog) {
            showDialog(relaunchDialog);
            setRelaunchDialog(undefined);
        } else {
            hideDialog();
        }
    };

/*    const createPdfThumnailBase64 = async (
    blob: Blob,
    scale = 0.5   // 50% size
    ): Promise<string> => {
        const buffer = await blob.arrayBuffer();

        const srcPdf = await PDFDocument.load(buffer);
        const outPdf = await PDFDocument.create();

        const pages = await outPdf.copyPages(
            srcPdf,
            srcPdf.getPageIndices()
        );

        pages.forEach(page => {
            const { width, height } = page.getSize();

            page.setSize(width * scale, height * scale);
            outPdf.addPage(page);
        });

        const base64 = await outPdf.saveAsBase64();

        return `data:application/pdf;base64,${base64}`;
    };*/

    const renderInvoiceGroupCoverLetterPdf = async (letterData: InvoiceGroupCoverLetter) => {
        // dispatch(push('/project-billing/invoicegroups/coverletter', { document: sampleInvoiceGroupCoverLetter }));
        // createPdfThumbnailBase64
        const receipt = new Receipt();
        // const invoiceGroupCoverLetter = sampleInvoiceGroupCoverLetter;
        // invoiceGroupCoverLetter.groupNumber = letterData.groupNumber.toString();
        const coverLetterPayload = letterData as unknown as IInvoiceGroupCoverLetterDocument;
        const blob = await pdf(<InvoiceGroupCoverLetterPdf invoice={coverLetterPayload} />).toBlob();
        const arrayBuffer = await blob.arrayBuffer();
        setIgCoverLetterBytes(new Uint8Array(arrayBuffer));
        const pdfBase64 = await createPdfThumbnailBase64(arrayBuffer);
        // receipt.base64InvoiceThumbnailString = await createPdfThumnailBase64(blob);
        receipt.base64InvoiceThumbnailString = pdfBase64;
        receipt.fileDate = new Date().toISOString().split('T')[0];
        receipt.fileSize = blob.size;
        receipt.fileName = letterData.groupIrNumber + '_Cover_Page_thumbnail.png';
        setReceiptThumbnails([new Receipt()]);
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `InvoiceGroupCoverLetter.pdf`;
        link.click();
    };
/*
    const renderInvoicePdf = async (invoice: IInvoiceDocument): Promise<Uint8Array> => {
        const blob = await pdf(<InvoicePdf invoice={invoice} />).toBlob();
        return new Uint8Array(await blob.arrayBuffer());
    };

    const concatPdfs = async (pdf1: Uint8Array, pdf2: Uint8Array): Promise<Uint8Array> => {
        const doc1 = await PDFDocument.load(pdf1);
        const doc2 = await PDFDocument.load(pdf2);
      
        const merged = await PDFDocument.create();
      
        const pages1 = await merged.copyPages(doc1, doc1.getPageIndices());
        pages1.forEach(p => merged.addPage(p));
      
        const pages2 = await merged.copyPages(doc2, doc2.getPageIndices());
        pages2.forEach(p => merged.addPage(p));
      
        return await merged.save();
    };

     const generateMergedPdf = async (invoiceNumber: string) => {
        // Render invoice to PDF bytes
        const invoicePdfBytes = await renderInvoicePdf(sampleInvoice);
      
        // Load an existing PDF (from fetch, fs, or local file)
        const payPeriod = getTimePeriodNumber(invoiceDocument.endDate);
        const tsBlob = await getTimesheetReportFileBytes(2, payPeriod, Number(invoiceNumber));
      
        if (!tsBlob) {
          console.log('Failed to load timesheet PDF');
          return;
        }
      
        const tsArrayBuffer = await tsBlob.arrayBuffer();
        const timesheetPdfBytes = new Uint8Array(tsArrayBuffer);
      
        // Merge
        const mergedPdf = await concatPdfs(invoicePdfBytes, timesheetPdfBytes);
      
        // Download in browser
        const blob = new Blob([mergedPdf], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `Invoice_${sampleInvoice.invoiceNumber}_merged.pdf`;
        link.click();
    }; */

    const getJwtToken = (): string => {
        return localStorage.getItem('jwt') || sessionStorage.getItem('jwt');
    };

    const downloadInvoiceFileBlob = async (invoiceNumber: string, docType: string, returnBlob: boolean = false) => {
        if (!invoiceNumber) {
            return null;
        }

        await get(`v1.0/AccountsPayable/invoice/${invoiceNumber}/document/${docType}`);

        if (!response.ok) {
            return null;
        }

        const blob = await response.blob();

        if (!returnBlob) {
            // Create an isolated download link
            (() => {
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = `Invoice_${invoiceNumber ?? 'unknown'}_${docType}.pdf`;
                link.click();
            })();
            return null; // Nothing to return when downloading
        }

        // Return the blob when requested
        return blob;
    };

    const handleDownloadInvoiceDocument = async (doc: InvoiceDoc) => {
        if (doc.hasBlob) {
            // Download the blob from the database
            downloadInvoiceFileBlob(doc?.invoiceNumber?.toString(), doc.documentType);
        } else {
            // Download from S3
            await downloadInvoiceFile(doc);
        }
    };

/*     const handleGetInvoiceGroupSubcodes = async () => {
        resetInvoiceGroupSubcodeSearchOptions();
    }; */

    const updateInvoiceGroupSections = async (payload: Array<InvoiceGroupSubcode>) => {
        let result = await post(`/v1.0/AccountsPayable/invoicegroup/sections/update`, payload);

        if (response.ok && result < 1) {
            console.log('Unable to update Invoice Group sections!');
        }
    };

    const getInvoiceGroupSubcodes = async () => {
        const queryString = invoiceGroupSubcodeSearchOptions?.toString();
        let result = await get(`/v1.0/AccountsPayable/invoice/group/subcodes${queryString}`);

        if (response.ok && result?.length > 0) {
            setIgSubcodes(result);
        } else {
            setIgSubcodes([]);
            console.log('Unable to get Invoice Group Data!!!');
        }
    };

    const downloadInvoiceFile = async (doc: InvoiceDoc) => {
        const fileName =
            doc.invoiceNumber +
            '_' +
            doc.documentType +
            (doc.documentType === 'CSV' ? '.csv' : '.pdf');

        const safeKey = encodeURIComponent(doc.s3Key);
        const url = `/v1.0/s3bucket/${safeKey}`;

        try {
            await get(url);

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`);
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = blobUrl;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(blobUrl);
        } catch (err) {
            const baseUrl = process.env.REACT_APP_BASE_API_URL;

            // fallback for large files / fetch failures
            window.open(baseUrl + url, '_blank', 'noopener,noreferrer');
        }
    };

/*     const getInvoiceFileBytes = async (keyName: string): Promise<Blob | null> => {
        const safeKey = encodeURIComponent(keyName);
        await get(`/v1.0/s3bucket/${safeKey}`);

        const clonedResponse = _.cloneDeep(response);
        if (clonedResponse.ok) {
            const blob = await clonedResponse.blob();
            return blob;
        }

        return null;
    };
        const handleBOPTimesheets = () => {
        alert('Implement BOP Time sheets');
    }; */

    const showInvoiceGroupingDialog = () => {
        showDialog(DialogList.INVOICE_GROUPING);
    };

    const showInvoiceGroupCoverLetterDialog = () => {
        showDialog(DialogList.EDIT_IG_COVER_LETTER);
    };

    const saveInvoiceDescription = (editedDescription: string) => {
        upsertInvoiceDetail(editedDescription);
    };

    const handleInvoiceList = () => {
        showDialog(DialogList.GENERATE_EXCEL_INVOICE_LIST);
    };

    const handleExcelSummary = () => {
        showDialog(DialogList.GENERATE_EXCEL_SUMMARY);
    };

    const handleZipArchive = () => {
        const formValues = getValues().invoices as Array<{ number: number; selection: boolean }>;
        const selectedSet = new Set(
            formValues.filter(f => f.selection).map(f => f.number)
        );
        if (!selectedSet.size) {
            alert('No invoices selected.');
            return;
        }
        const allSelected = invoices.filter(inv => selectedSet.has(Number(inv.number)));
        const docsToZip = new Array<InvoiceDoc>();
        allSelected.forEach((i) => {
            docsToZip.concat(i.documents);
        });

        const payload = invoices[selectedInvoiceIndex].documents;
        getZipArchivedDocuments(payload);
    };

    const handlePostToAR = () => {
        postInvoicesToAr();
    };

/*     const handleListInvoices = () => {
        getInvoiceListFile(selectedBeginDate, selectedEndDate);
    }; */

    const handleInvoiceListing = () => {
        showDialog(DialogList.GENERATE_INVOICE_LISTING);
    };

    const downloadInvoicePdfBytes = async (s3Key: string): Promise<Uint8Array | null> => {
        // Encode the S3 key in the URL
        const baseUrl = process.env.REACT_APP_BASE_API_URL;
        const url = `${baseUrl}/v1.0/s3bucket/${encodeURIComponent(s3Key)}`;

        // Make the fetch request
        const result = await fetch(url, {
            method: 'GET',
            headers: {
            Authorization: `Bearer ${getJwtToken()}`
            }
        });

        // Check for success
        if (!result.ok) {
            console.log('Download failed', result.statusText);
            return null;
        }

        // Convert response to Uint8Array
        const arrayBuffer = await result.arrayBuffer();
        return new Uint8Array(arrayBuffer);
    };

    const viewSelectedInvoices = () => {
        getInvoiceThumbnails();
    };

/*     const uploadInvoicePdf = async (invoice: IInvoiceDocument) => {
        const blob = await pdf(<InvoicePdf invoice={invoice} />).toBlob();

        // Construct metadata query params
        const params = new URLSearchParams({
            org: 'Dudley-Land',
            dept: 'Accounting',
            env: 'test',
            medium: 'docs',
            family: 'Invoices',
            category: 'Invoice',
            invoiceNo: selectedInvoiceIndex !== null && selectedInvoiceIndex !== undefined && !!invoices &&
                !!invoices[selectedInvoiceIndex]?.number && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex]?.number.toString() : '0',
            date: new Date().toISOString().slice(0, 10),
            format: 'pdf',
            documentType: '1',
            source: 'C'
        });

        // Send blob as the request body
        const result = await fetch(`http://localhost:4000/api/v1.0/s3bucket/AccountsReceivable/invoices/documents?${params}`, {
            method: 'POST',
            body: blob,
            headers: {
              Authorization: `Bearer ${getJwtToken()}`,
              'Content-Type': 'application/pdf'
        }});

        if (result) {
            console.log(result);
        }

        if (!response.ok) {
            throw new Error('Upload failed');
        }
    }; */

    const cancelGeneration = () => {
        setGeneratingDocument(false);
        hideDialog();
    };

    const uploadInvoiceDocPdf = async (blob: Blob, docCategory: string, invoiceNumber: string, docSource: string = 'C', docType: string = 'pdf') => {
        // Construct metadata query params
        const params = new URLSearchParams({
            org: 'Dudley-Land',
            dept: 'Accounting',
            env: 'test',
            medium: 'docs',
            family: 'Invoices',
            category: docCategory,
            invoiceNo: !!invoiceNumber ? invoiceNumber : '0',
            date: new Date().toISOString().slice(0, 10),
            format: docType,
            documentType: docCategory === 'INVOICE'
                ? '1' : docCategory === 'TIMESHEET'
                ? '2' : docCategory === 'OFFEXP'
                ? '3' : docCategory === 'RECEIPT'
                ? '4' : docCategory === 'BOPTS'
                ? '5' : docCategory === 'CSV'
                ? '6' : docCategory === 'MERGE'
                ? '7' : '0',
            source: docSource
        });

        // Send blob as the request body
        const baseUrl = process.env.REACT_APP_BASE_API_URL;
        const result = await fetch(`${baseUrl}/v1.0/s3bucket/AccountsReceivable/invoices/documents?${params}`, {
            method: 'POST',
            body: blob,
            headers: {
              Authorization: `Bearer ${getJwtToken()}`,
              'Content-Type': params.get('format') === 'pdf' ? 'application/pdf' : 'text/csv'
        }});

        if (result) {
            getMasterInvoices();
            getInvoiceDocs(Number(invoiceNumber), false);
            getArchivedInvoiceDocs(Number(invoiceNumber), false);
            setGeneratingDocument(false);
        }

        if (!response.ok) {
            throw new Error('Upload failed');
        }
    };

    const setSelectedPayPeriodValue = (value: string) => {
        if (!value) {
            setSelectedPayPeriod(undefined);
            return;
        }
        if (Array.isArray(payPeriods)) {
            const labelValue: PayPeriod = payPeriods.find((pp) =>
                pp.id.toString() === value
            );
            if (!!labelValue?.name) {
                setSelectedPayPeriod(labelValue.name.toString().replace('-', ''));
            }
        }
    };

    const normalizeInvoiceGroupSubcodes = (items: InvoiceGroupSubcode[]): InvoiceGroupSubcode[] => items.map(i => ( {
        ...i,
        sectionId: i.sectionId != null ? Number(i.sectionId) : undefined,
        sectionNumber: Number(i.sectionNumber),
        groupNumber: Number(i.groupNumber),
        prospectGroupNumber: Number(i.prospectGroupNumber),
        daysBilled: Number(i.daysBilled),
        unclosedInvoices: Number(i.unclosedInvoices),
        latestTimeEntry: new Date(i.latestTimeEntry)
    }));

    const handleConfirmEditInvoiceGroup = (groupDefinition: TsdiInvoiceGroup) => {
        const invoiceGroupForUpdate = Array.isArray(creatingGroup) ? new TsdiInvoiceGroup() : _.cloneDeep(invoiceGroup);
        if (!invoiceGroupForUpdate) {
            return;
        }
        invoiceGroupForUpdate.description = groupDefinition.description;
        if (Array.isArray(creatingGroup)) {
            invoiceGroupForUpdate.accountCode = groupDefinition.accountCode;
            invoiceGroupForUpdate.projectId = selectedProject?.id;
            invoiceGroupForUpdate.creationDate = new Date();
            invoiceGroupForUpdate.closeDate = null;
            invoiceGroupForUpdate.closedBy = null;
            invoiceGroupForUpdate.closedByName = null;
            invoiceGroupForUpdate.groupTotal = null;
            // count
            invoiceGroupForUpdate.createdBy = tsdiNumber;
            invoiceGroupForUpdate.createdByName = tsdiName;
            invoiceGroupForUpdate.frequency = groupDefinition.frequency;
            invoiceGroupForUpdate.requestDate = groupDefinition.requestDate;
            invoiceGroupForUpdate.invoiceDate = groupDefinition.invoiceDate;
            // invoice group date
            // begin date
            invoiceGroupForUpdate.addSections = normalizeInvoiceGroupSubcodes(_.cloneDeep(creatingGroup));
            createInvoiceGroup(invoiceGroupForUpdate);
        } else {
            updateInvoiceGroup(invoiceGroupForUpdate);
        }

        setOpenInvoiceGrouping(new Object());
    };

/*     const sampleInvoiceGroupCoverLetter: IInvoiceGroupCoverLetterDocument = {
        dateTime: 'October 2, 2025 02:07 PM',
        groupNumber: '6940',
        clientName: 'Coterra Energy Inc.,',
        clientContact: 'Coterra Energy Inc.',
        clientAddress: '2000 Park Lane, Suite 300',
        clientCity: 'Pittsburgh',
        clientState: 'PA',
        clientZip: '15275',
        qlsNumber: '1387.2.93',
        billingClerk: 'Brittany Plunkett',
        projectName: 'Susquehanna Abstracting Project',
        department: 'Auburn',
        wellName: '216.00-1,021.01,000 (Allan Garrison)',
        parcelNumbers: '1, 2, 3',
        afeNumber: '12345',
        firstParagraph: 'This invoice group covers all costs for the above named project. Please contact me if you have any concerns with the enclosed.'
    }; */

    const  createPdfThumbnailBase64 = async (
        file: File | ArrayBuffer,
        scale = 0.25     // 25% size thumbnail
    ): Promise<string> => {
        const buffer =
        file instanceof File ? await file.arrayBuffer() : file;

        const pdfDoc: PDFDocumentProxy = await pdfjs
            .getDocument({ data: buffer })
            .promise;

        const page: PDFPageProxy = await pdfDoc.getPage(1);

        const viewport = page.getViewport({ scale });

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d')!;

        canvas.width = viewport.width;
        canvas.height = viewport.height;

        await page.render({
            canvasContext: ctx,
            viewport
        }).promise;

        return canvas.toDataURL('image/png');
    };

    const handleGenerateIgDocuments = () => {
        hideDialog();
        setOpenGenerateIgDocs(new Object());
    };

    const onConfirmGenerateIgDocs = () => {
        const groupNumber = invoiceGroup?.groupNumber ? invoiceGroup?.groupNumber : undefined;
        if (groupNumber) {
            generateInvoiceGroupDocuments(groupNumber);
            setOpenInvoiceGrouping(new Object());
        }
    };

    return (
        <>
        <a style={{ display: 'hidden' }} id="timesheetReport" />
        <a style={{ display: 'hidden' }} id="baseCsvFile" />
        <div>
        <PBNavBar/>
        <ClientProjectSearch
            parentComponent={'InvoiceMaintenancePageComponent'}
            selectedPayperiod={selectedPayPeriod}
            selectedClient={selectedClient}
            selectedProject={selectedProject ? selectedProject?.number : selectedProjectNumber}
            setSelectedTotal={setSelectedTotal}
            setSelectedSource={setSelectedSource}
            setSelectedCreatedByNumber={setSelectedCreatedByNumber}
            setSelectedFormatType={setSelectedFormat}
            clearSearchFilters={clearInvoiceSearchOptions}
            setPayPeriodSearchTerm={setPayPeriodSearchTerm}
            setSelectedGroupNumber={setSelectedGroupNumber}
            setSelectedClient={setSelectedClient}
            setSelectedProject={setSelectedProject}
            setSelectedSubcode={setSelectedSubcode}
            setSelectedAltSubcode={setSelectedAltSubcode}
            setSelectedOffice={setSelectedOffice}
            setSelectedPayPeriod={setSelectedPayPeriodValue}
            setSelectedBeginDate={setSelectedBeginDate}
            setSelectedEndDate={setSelectedEndDate}
            setSelectedInvoiceDate={setSelectedInvoiceDate}
            setInvoiceSearchTerm={setInvoiceSearchTerm}
            setExcludePosted={setExcludePostedInvoices}
            setSortDirection={setSortDirection}
            setTotalLike={setTotalLike}
            setExcludeUnPosted={setExcludeUnPostedInvoices}
            setExcludeVoid={setExcludeVoidInvoices}
            setExcludeNonVoid={setExcludeNonVoidInvoices}
            unpostedInvoiceOption={true}
            clients={clients}
            offices={officeOptionValues ? officeOptionValues.map(o => { return o.label; }) : []}
            projects={true}
            subcodes={true}
            altSubcodes={true}
            runQuery={runQuery}
            size={12}
            invoices={invoices}
            payPeriods={!!payPeriods && payPeriods.length > 0 ?
                payPeriods?.map((pp) => { return {id: pp?.id, name: !!pp?.name ? pp?.name : ''}; }) : []}
            invoiceGroups={invoiceGroups}
        />
           <div style={{display: 'flex', flexDirection: 'column', width: '100vw', justifyContent: 'center'}}>
            <div style={{width: '100%'}}>
                <Page className="dlc-maxer-width">
                    <Page.Section width={12}>
                        <Panel backgroundColor="#D3D3D3">
                            <Panel>
                                <div className="form-row" style={{ textAlign: 'left', verticalAlign: 'middle', justifyContent: 'left', margin: 0, padding: 0 }}>
                                    <Button
                                        className={'project-billing blue-hover-button'}
                                        style={{ width: '6%', height: '3rem' }}
                                        text={isGeneratingInvoices ? 'Generating' : 'Generate'}
                                        title={!isGeneratingInvoices ? `Generate Invoices` : `Generating Invoices`}
                                        disabled={isGeneratingInvoices}
                                        loading={isGeneratingInvoices}
                                        onClick={() => !isGeneratingInvoices ? GenerateInvoices() : alert('Invoices are already generating')}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', width: '6%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Select All'}
                                        onClick={() => selectAllInvoices()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Deselect All'}
                                        onClick={deselectAllInvoices}
                                    />
                                    {/*<Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '4%', height: '3rem', marginLeft: '1rem' }}
                                        text={'List'}
                                        title={'List Selected Invoices'}
                                        onClick={() => handleListInvoices()}
                                    />*/}
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '4%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Listing'}
                                        title={'Generate Listing for Selected Invoices'}
                                        onClick={() => handleInvoiceListing()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={'View Selected'}
                                        onClick={() => viewSelectedInvoices()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Breakdown'}
                                        onClick={() => openWindowsBreakdownDialog()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ whiteSpace: 'nowrap',  width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Create Invoice'}
                                        title={`Create a 'manual' invoice.`}
                                        onClick={createManualInvoice}
                                    />
{/*                                     <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Generate Timesheet'}
                                        type={'submit'}
                                        onClick={() => generateTimesheet()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Generate OE'}
                                        type={'submit'}
                                        onClick={() => handleGenerateOfficeExpensesDocument()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Generate Summary'}
                                        type={'submit'}
                                        onClick={() => generateTimeSummary()}
                                    /> */}
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap',  width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Project Billing'}
                                        onClick={() => projectBilling()}
                                    />
                                    {/* <PDFDownloadLink
                                        className="dlc-form-button-default normal blue-hover-button"
                                        document={<InvoicePdf invoice={sampleInvoice} />}
                                        fileName={`Invoice_${sampleInvoice.invoiceNumber}.pdf`}
                                        style={{textDecoration: 'none', marginLeft: '1rem', color: 'inherit', paddingBottom: '2px'}}
                                    >
                                        {({ loading }) => (loading ? 'Loading...' : <label style={{paddingTop: '.9rem', whiteSpace: 'nowrap'}}>Download Invoice</label>)}
                                    </PDFDownloadLink> */}
                                    <Button
                                        className={'project-billing blue-hover-button'}
                                        style={{ whiteSpace: 'nowrap', width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={generatingDocument ? 'Generating' : 'Generate Documents'}
                                        disabled={generatingDocument}
                                        loading={generatingDocument}
                                        onClick={() => !generatingDocument ? generateDocuments() : {}}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '8%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Summary (Excel)'}
                                        onClick={() => handleExcelSummary()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Post (A/R)'}
                                        onClick={() => handlePostToAR()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        title={'Get Excel Invoice List'}
                                        text={'Invoice List (Excel)'}
                                        onClick={() => handleInvoiceList()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '6%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Groups'}
                                        onClick={() => showInvoiceGroupingDialog()}
                                    />
                                    <Button
                                        className={isGeneratingZip ? 'project-billing button-pulse' : 'blue-hover-button'}
                                        style={{ whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        text={isGeneratingZip ? 'Generating' : 'Archive (.zip)'}
                                        disabled={isGeneratingZip}
                                        loading={isGeneratingZip}
                                        onClick={() => !isGeneratingZip ? handleZipDocuments() : alert('Zip archive is already generating')}
                                    />
{/*                                     <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Archive (.zip)'}
                                        onClick={() => handleZipArchive()}
                                    /> */}
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '7%', height: '3rem', marginLeft: '1rem' }}
                                        text={'SupplierLink'}
                                        onClick={() => handleOpenSupplierLinkCsvDialog()}
                                    />
                                    {/* <Button
                                        className="blue-hover-button"
                                        style={{ width: '10%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Reoccuring'}
                                        onClick={() => buttonClick}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '10%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Exit'}
                                        onClick={() => buttonClick}
                                    /> */}
                                </div>
                                <div className="form-row" style={{ textAlign: 'left', verticalAlign: 'middle', justifyContent: 'left', margin: 0, padding: 0, marginTop: '.5rem' }}>
{/*                                     <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '13%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Backup Time Sheets'}
                                        onClick={() => handleBOPTimesheets()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{whiteSpace: 'nowrap', width: '14%', height: '3rem', marginLeft: '1rem' }}
                                        text={'Generate OE Receipts'}
                                        type={'submit'}
                                        onClick={() => handleGenerateOfficeExpenseReceiptDocument()}
                                    /> */}
                                    {tsdiNumber === 6768 && <a href="kudusuite:C:/Users/Public/Temp/BackOfficeAccountingDiagram.pdf">
                                        Open PDF
                                    </a>}
                                </div>
                            </Panel>
                        </Panel>
                    </Page.Section>
                </Page>
                <Page className="dlc-maxer-width">
                        <Page.Section width={12}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayTitle()}>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', padding: '.5rem' }}>
                                    <form id={`ProjectStaffingForm`} onSubmit={onSubmit}>
                                        <div className="form-row" style={{ marginBottom: '0' }}>
                                            <label style={{color: 'rgb(99, 147, 193)', fontSize: '22px'}}>
                                                Billing Code: {!!selectedClient?.clientNumber ? selectedClient?.clientNumber :
                                                    ''}.{!!selectedProject?.number ? selectedProject.number :
                                                        ''} ({!!selectedClient?.clientName ? selectedClient.clientName :
                                                            ''} - {!!selectedProject?.name ? selectedProject.name : ''})
                                            </label>
                                            {selectedPayPeriod && <label style={{color: 'rgb(99, 147, 193)', fontSize: '22px', marginLeft: '1rem'}}>
                                                Pay Period: {selectedPayPeriod}
                                            </label>}
                                            {selectedOffice && <label style={{color: 'rgb(99, 147, 193)', fontSize: '22px', marginLeft: '1rem'}}>
                                                Office: {selectedOffice}
                                            </label>}
                                            {/*<Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Reports"
                                                reactIcon={VscGraph}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center', marginTop: '.4rem'}}
                                                onClick={() => reportOptions()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Add New Client"
                                                reactIcon={BiAddToQueue}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2.5rem', height: '2.5rem', verticalAlign: 'center'}}
                                                onClick={() => findClient()}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to First Record"
                                                reactIcon={BiArrowToLeft}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Move to First Record')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Previous Record"
                                                reactIcon={BiLeftArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={moveToPreviousProject}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Next Record"
                                                reactIcon={BiRightArrowAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Move to next project')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Move to Last Record"
                                                reactIcon={BiArrowToRight}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => alert('Move to last Record')}
                                            />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Billing Accounts"
                                                reactIcon={FaFileAlt}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => generateReports()}
                                            />
                                            <a style={{ display: 'hidden' }} id="a_voucherCheck" />
                                            <Button
                                                style={{ height: '3rem', marginLeft: '1rem', background: 'transparent'}}
                                                text={''}
                                                title="Prospect by Manager"
                                                reactIcon={FaUserTie}
                                                iconHoverColor="blue"
                                                iconStyle={{width: '2rem', height: '2rem', verticalAlign: 'center'}}
                                                onClick={() => prospectByManagerReport()}
                                            />*/}
                                        </div>
                                        </form>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                    <Page className="dlc-maxer-width">
                        <Page.Section width={14}>
                            <Panel backgroundColor="#D3D3D3">
                                <Panel panelTitle={displayHeading2()}>
                                    <div style={{marginBottom: '1rem', display: 'flex', width: '100%', justifyContent: 'center'}}>
                                        {displayInoiceMasterButtons()}
                                    </div>
                                    <div style={{ border: 'solid rgb(99, 147, 193) 1px', paddingBottom: '.5rem' }}>
                                        <form>
                                            {loadingInvoices && (
                                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                    <span>Loading Invoices...</span>
                                                    <LoadingSpinner />
                                                </div>
                                            )}
                                            {!loadingInvoices && displayInvoiceList()}
                                        </form>
                                    </div>
                                </Panel>
                            </Panel>
                        </Page.Section>
                    </Page>
                </div>
            </div>
        </div>
        <AddInvoiceDocumentDialog
            dialogName={DialogList.ADD_INVOICE_DOCUMENT}
            hideDialog={hideDialogAndOpenDocumentManagement}
            invoiceDocumentTypes={invoiceTypes}
            handleAddDocument={handleGenerateDocument}
        />
        <GenerateTimesheetDialog
            dialogName={DialogList.GENERATE_TIMESHEET}
            hideDialog={hideDialogAndOpenDocumentManagement}
            showDialog={showDialog}
            handleSubmit={handleGenerateTimesheetDocument}
            setGeneratingDocument={setGeneratingDocument}
        />
        <GenerateTimeSummaryDialog
            dialogName={DialogList.GENERATE_TIME_SUMMARY}
            hideDialog={hideDialog}
            showDialog={showDialog}
            handleSubmit={handleCreateSummaryDocument}
            payPeriods={payPeriods}
        />
        <GenerateInvoiceListingDialog
            dialogName={DialogList.GENERATE_INVOICE_LISTING}
            hideDialog={hideDialog}
            showDialog={showDialog}
            offices={officeOptionValues}
            handleSubmit={handleGenerateInvoiceListing}
        />
        <CreateInvoiceDialog
            client={!!selectedClient?.clientNumber ? selectedClient.clientNumber : selectedClientNumber ? selectedClientNumber : undefined}
            project={!!selectedProject?.number ? selectedProject.number : undefined}
            dialogName={DialogList.CREATE_MANUAL_INVOICE}
            hideDialog={hideDialog}
            handleSubmit={handleCreateManualInvoice}
            showDialog={showDialog}
            offices={officeOptionValues}
        />
        <InvoiceDescriptionDialog
            dialogName={DialogList.INVOICE_DESCRIPTION}
            hideDialog={hideDialog}
            invoice={!!invoices && invoices?.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex] : null}
            handleConfirm={saveInvoiceDescription}
        />
        <InvoiceBreakdownDialog
            payPeriod={selectedPayPeriod}
            dialogName={DialogList.INVOICE_BREAKDOWN}
            hideDialog={hideDialog}
            showDialog={showDialog}
            companyName={'Dudley Land'}
        />
        <InvoiceDetailsDialog
            deleteSelected={deleteInvoiceDetail}
            dialogName={DialogList.INVOICE_DETAILS}
            handleConfirm={updateInvoiceDetail}
            hideDialog={hideDialog}
            invoiceTypes={invoiceDetailTypes}
            invoiceDetails={invoices && Array.isArray(invoices) && invoices.length > selectedInvoiceIndex &&
                Array.isArray(invoices[selectedInvoiceIndex]?.details) ? invoices[selectedInvoiceIndex].details : []}
        />
        <EditInvoiceGroupNameDialog
            dialogName={DialogList.EDIT_INVOICE_GROUP}
            hideDialog={hideDialog}
            handleConfirm={handleConfirmEditInvoiceGroup}
            invoiceGroup={invoiceGroup}
            create={creatingGroup}
            projectId={selectedProject?.id}
        />
        <GenerateInvoicesDialog
            clients={clients}
            setClientSearchTerm={setClientSearchTerm}
            offices={officeOptionValues}
            onGenerateInvoices={onGenerateInvoices}
            periodTypes={[
                {code: 1, description: 'Weekly'},
                {code: 2, description: 'Semi-Monthly'},
                {code: 3, description: 'Monthly'}
            ]}
            dialogName={DialogList.GENERATE_INVOICES}
            hideDialog={hideDialog}
            currentUser={!tsdiNumber ? appContext?.currentUser?.userId : tsdiNumber}
            payPeriod={!!selectedPayPeriod && Array.isArray(payPeriods) && getPayPeriodAsString(selectedPayPeriod)}
        />
        <VoidInvoiceDialog
            handleConfirm={handleVoidOrArchive}
            invoiceNumber={selectedInvoiceIndex !== undefined && selectedInvoiceIndex !== null && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].number : null}
            invoice={selectedInvoiceIndex !== undefined && selectedInvoiceIndex !== null && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex] : null}
            dialogName={DialogList.VOID_INVOICE}
            hideDialog={hideDialog}
            currentUser={appContext?.currentUser?.username}
            forDocumentArchive={updatingDocument}
        />
        <InvoiceDocumentCreationDialog
            handleConfirm={handleBulkDocumentGeneration}
            dialogName={DialogList.GENERATE_INVOICE_DOCUMENTS}
            hideDialog={cancelGeneration}
            invoicesDocTypes={invoiceTypes}
            assignToNumber={!!tsdiNumber ? tsdiNumber.toString() : ''}
        />
        <InvoiceDocumentManagementDialog
            dialogName={DialogList.MANAGE_INVOICE_DOCUMENTS}
            hideDialog={hideDialog}
            handleConfirm={hideDialogAndOpenInvoiceGroups}
            deleteDocument={handleDeleteDocument}
            invoiceNumber={selectedInvoiceIndex !== undefined && !!invoices && invoices.length > selectedInvoiceIndex ? invoices[selectedInvoiceIndex].number : 'unknown'}
            invoiceGroupNumber={igNumber ? igNumber : 'unknown'}
            documentList={invoiceDocs}
            igDocumentList={invoiceGroupDocs}
            archivedDocumentList={archivedInvoiceDocs}
            downloadDocument={handleDownloadInvoiceDocument}
            createDocument={handleCreateDocument}
            getBaseCSV={handleGetBaseCsvFile}
            mergeDocuments={mergeExistingInvoiceDocuments}
            invoiceTypes={invoiceTypes}
            createNewTimesheet={generateTimesheet}
            addDocument={() => handleAddDocuments()}
            setGeneratingDocument={setGeneratingDocument}
            generatingDocument={generatingDocument}
            getExpenseReceipts={getExpenseReceiptsForInvoice}
            veiwExpenseReceipts={handleGetReceipts}
            userIsAdmin={appContext.currentUser.isAdmin}
        />
        <ReceiptViewerDialog
            pdfBytes={igCoverLetterBytes}
            context={receiptViewContext}
            handleConfirm={handleCloseReceiptViewerDialog}
            dialogName={DialogList.RECEIPT_VIEWER}
            hideDialog={hideDialog}
            receipts={_.isArray(receiptThumbnails) && receiptThumbnails.length > 0 ? receiptThumbnails : (_.isArray(invoiceThumbnails) && invoiceThumbnails.length > 0 ? invoiceThumbnails : [])}
        />
        <InvoiceGroupingDialog
            setShowInvoiceGroups={setShowInvoiceGroups}
            dialogName={DialogList.INVOICE_GROUPING}
            hideDialog={hideDialog}
            showDialog={showDialog}
            client={selectedClient}
            project={selectedProject}
            subCodes={igSubcodes}
            showEditInvoiceGroupDialog={() => showDialog(DialogList.EDIT_INVOICE_GROUP)}
            setInvoiceGroup={setInvoiceGroup}
            setInvoiceGroups={setInvoiceGroups}
            generateInvoiceGroupCoverLetter={showInvoiceGroupCoverLetterDialog}
            setCreatingInvoiceGroup={setCreatingGroup}
            setAddingSections={setAddSections}
            setInvoiceGroupRequests={setInvoiceGroupRequests}
            handleViewDocumentMaintenance={handleViewDocumentMaintenance}
            getSupplierLinkCsv={handleGetIgSupplierLinkCsv}
            confirmDocumentGeneration={handleGenerateIgDocuments}
        />
        <NoSelectedInvoicesWarningDialog
            dialogName={DialogList.NO_SELECTED_INVOICES}
            hideDialog={hideDialog}
            heading={'No Invoices Selected'}
            label={'You must select at least 1 invoice.'}
        />
        <ConfirmGenerateInvoiceDocumentsDialog
            dialogName={DialogList.CONFIRM_GENERATE_IG_DOCS}
            hideDialog={hideDialog}
            heading={'Generate Invoice Group Documents'}
            label={'Click Generate to confirm Invoice Group document generation'}
            igNumber={selectedGroupNumber}
            confirmGenerateIgDocs={onConfirmGenerateIgDocs}
        />
        <InvoiceGroupCoverLetterDialog
            clients={clients}
            dialogName={DialogList.EDIT_IG_COVER_LETTER}
            hideDialog={hideDialog}
            previewDocument={renderInvoiceGroupCoverLetterPdf}
            setRelaunchDialog={setRelaunchDialog}
            invoiceGroupRequests={invoiceGroupRequests}
            onUpdateIgRequest={prepareUpdateInvoiceGroupRequest}
        />
        <GenerateExcelSummaryDialog
            dialogName={DialogList.GENERATE_EXCEL_SUMMARY}
            showDialog={showDialog}
            hideDialog={hideDialog}
            summaryOptions={[
                {id: 1, summaryOption: 'Generic Client'},
                {id: 2, summaryOption: 'COG'},
                {id: 3, summaryOption: 'Devon'},
                {id: 4, summaryOption: 'Matrix'},
                {id: 5, summaryOption: 'Panther Energy'},
                {id: 6, summaryOption: 'Peregrine'}
            ]}
            handleSubmit={handleGenerateExcelSummary}
        />
        <GenerateExcelInvoiceListDialog
            dialogName={DialogList.GENERATE_EXCEL_INVOICE_LIST}
            showDialog={showDialog}
            hideDialog={hideDialog}
            officeOptions={officeOptionValues ? officeOptionValues?.map(o => ({id: Number(o.value), office: o.label})) : []}
            handleSubmit={handleGenerateExcelInvoiceList}
        />
        <GenerateSupplierLinkCsvDialog
            dialogName={DialogList.GENERATE_SUPPLIER_LINK_CSV}
            showDialog={showDialog}
            hideDialog={hideDialog}
            officeOptions={officeOptionValues ? officeOptionValues.map(o => ({id: Number(o.value), office: o.label})) : []}
            handleSubmit={handleGetSupplierLinkCsv}
        />
        <div hidden={true}>
            <a id="a_InvoiceDoc" />
        </div>
        </>
    );
};

export default InvoiceMaintenancePageComponent;



// WEBPACK FOOTER //
// ./src/components/project-billing/pages/InvoiceMaintenancePageComponent.tsx